{
  "app": {
    "name": "Molvia"
  },
  "outdated": {
    "line": "Браузер устарел — откройте Molvia в свежем Chrome, Safari, Firefox или Edge"
  },
  "nav": {
    "label": "Разделы",
    "advice": "Что брать",
    "verdicts": "Оценки",
    "back_label": "Назад",
    "money": "Деньги",
    "settings": "Настройки",
    "purchases": "Покупки"
  },
  "state": {
    "loading": "Загружаем…",
    "retry": "Повторить",
    "retrying": "Повторяем…",
    "report": "Сообщить о проблеме"
  },
  "trip": {
    "title": "Запись",
    "add_item": "Добавить позицию",
    "add_short": "Позиция",
    "add_lead": "Новая",
    "scan_short": "Штрихкод",
    "scan_lead": "Сканировать",
    "unpriced": "без цены",
    "total": "Итого",
    "total_line": "С ценой — {priced} из {total} · без цены — {unpriced}",
    "receipt": {
      "total": "Итого по чеку",
      "add": "+ Сумма по чеку",
      "edit": "Изменить сумму по чеку",
      "line_prices": "по ценам {amount}",
      "line_prices_part": "по ценам {amount} — {n} из {total}",
      "line_meets": "с чеком сходится",
      "line_over": "чек меньше цен на {amount}",
      "line_under": "чек больше цен на {amount}",
      "line_unpriced": "без цены — {amount}",
      "line_none": "цен пока нет",
      "line_pending": "цены пересчитаем, когда покупки уйдут",
      "sending": "Сумма по чеку {amount} · отправляется",
      "removing": "Сумма по чеку убирается · отправляется",
      "sheet": {
        "title": "Сумма по чеку",
        "body": "Цены покупок останутся как есть",
        "label": "Сумма",
        "save": "Сохранить",
        "remove": "Убрать сумму"
      },
      "finish": {
        "body": "Без цены {n} из {total}. Впишите, сколько вышло по чеку, — сумма попадёт в «Деньги» целиком",
        "label": "Сколько вышло по чеку?"
      }
    },
    "unit_price": "{amount} за {unit}",
    "items_count": "{n} позиция | {n} позиции | {n} позиций",
    "footnote": "Обязательна только позиция. Цену и количество можно дописать позже — запись не заблокируется",
    "finish": "Закончить",
    "finish_confirm": {
      "title": "Закончить запись?",
      "body": "Позиции останутся записаны. Забытое можно дописать и потом",
      "body_receipt": "Сумма по чеку {amount} останется в «Деньгах». Позиции можно дописать и потом",
      "ok": "Закончить",
      "cancel": "Отмена"
    },
    "remove": {
      "action": "Удалить запись",
      "sheet": {
        "title": "Удалить запись?",
        "body": "Покупки и цены уйдут, из «Денег» и счетов тоже. Оценки останутся",
        "body_receipt": "Сумма по чеку {amount} уйдёт из «Денег» и счетов"
      },
      "empty": {
        "title": "В записи ничего нет",
        "body": "Удалить её, чтобы в «Покупках» не осталось пустой строки? Если есть только сумма чека — запишите её тратой в «Деньгах»",
        "finish": "Всё равно закончить",
        "spending": "Записать тратой в «Деньгах»"
      },
      "removed": "Запись удалена: {name}",
      "removed_announced": "Запись удалена: {name}. Вернуть — 10 секунд",
      "restore": "Вернуть",
      "restored": "Запись возвращена",
      "not_restored": "Запись не вернулась: {name}",
      "not_restored_open": "Пока её не было, начата другая запись, а открытой бывает только одна",
      "not_restored_gone": "Прошло больше десяти минут — запись удалена насовсем",
      "not_restored_recorded": "Пока её не было, этот чек записан снова — дважды один чек не записываем"
    },
    "empty": {
      "title": "Запись начата",
      "body": "Добавьте первую позицию — остальное можно дописать потом"
    },
    "error": {
      "title": "Сервер не ответил",
      "body": "Позиции остались на телефоне, ничего не потеряно",
      "strip": "Сервер не ответил · позиции остались на телефоне"
    },
    "offline": {
      "strip": "Без связи · позиции сохраняются на телефоне и уйдут сами"
    },
    "none": {
      "action": "Начать запись"
    },
    "home": {
      "pending": {
        "one_place": "Из {place}, последняя — {when}",
        "two_places": "Из {a} и {b}",
        "more_places": "Из {a}, {b} и других мест"
      }
    },
    "quantity": "{amount} {unit}",
    "queued": {
      "waiting": "ещё не ушло",
      "editing": "правка не ушла",
      "removing": "удаляется",
      "unnamed": "Позиция"
    },
    "rejected": {
      "title": "Одно изменение не принято сервером",
      "named": "«{name}» — сервер не принял",
      "unknown": "Сервер не принял изменение ({code})",
      "fix": "Поправить",
      "drop": "Убрать",
      "orphaned": "в ней {n} покупка, и она ждёт решения | в ней {n} покупки, и они ждут решения | в ней {n} покупок, и они ждут решения",
      "drop_trip": "Убрать запись с покупками"
    },
    "rate_line": "курс {rate} · {date}",
    "rate_line_source": "курс {rate} · {date} · {source}",
    "rate_line_mine": "мой курс {rate} · {date}",
    "flip": "Показать в другой валюте",
    "caveat": {
      "pending": "+ {n} позиция ещё не ушла | + {n} позиции ещё не ушли | + {n} позиций ещё не ушли",
      "partial": "пересчёт только по {currency}",
      "local": "запись ещё не ушла — итог появится после отправки"
    },
    "rate": {
      "source_cba": "ЦБ РА",
      "source_cbr": "ЦБ РФ",
      "source_erapi": "open.er-api.com",
      "fallback": "Курс не от {bank} — он молчит больше недели. Источник:",
      "stale_official": "Курс на {date} — с тех пор {bank} ничего не публиковал",
      "stale_fallback": "Курс на {date} — свежее никто ничего не опубликовал",
      "jump_title": "Курс прыгнул больше чем на четверть",
      "jump_previous": "{rate} вместо {previous} от {date}",
      "jump_alone": "{rate}, и прежнего курса рядом нет",
      "choose": "Выбрать курс",
      "sheet_title": "По какому курсу считать?",
      "sheet_meta": "Считается только пересчёт — сами цены не меняются",
      "new": "По новому",
      "old": "По прежнему",
      "mine": "Свой курс",
      "own": "ввести",
      "save": "Считать по нему",
      "saving": "Сохраняем…",
      "failed": "Не получилось сохранить выбор. Попробуйте ещё раз",
      "source_nbg": "НБ Грузии",
      "source_nbs": "НБ Сербии"
    },
    "start": {
      "title": "Где вы?",
      "other": "Другое место"
    },
    "unsent": {
      "title": "{n} покупка ещё не отправлена | {n} покупки ещё не отправлены | {n} покупок ещё не отправлено",
      "body": "Они на телефоне. Уйдут, когда появится сеть и приложение будет открыто"
    },
    "elsewhere": {
      "title": "Уже открыта запись в {place}",
      "body": "Продолжить открытую запись или закончить её и начать новую в {mine}? Покупки новой записи пока сохранены на телефоне и дождутся вашего выбора.",
      "body_other": "Покупки новой записи ({mine}) пока на телефоне. Если дописать их в открытую запись, они запишутся магазину {place} — цены одного магазина нельзя записывать другому, по ним потом и сравнивают.",
      "join": "Дописать в ту запись",
      "finish": "Закончить ту запись",
      "choose": "Выбрать запись"
    },
    "history": {
      "title": "Покупки",
      "error_title": "Не удалось загрузить покупки",
      "error_body": "Сохранённое осталось на телефоне. Попробуйте ещё раз.",
      "offline_title": "Без сети — сохранённые покупки",
      "offline_body": "Доступно то, что осталось на телефоне. Остальное загрузится со связью.",
      "local_finish": "Закончена на телефоне — ещё не отправлена",
      "more": "Показать ещё",
      "loading": "Загружаем…",
      "when": "{day}, {time}",
      "missing_title": "Покупки недоступны",
      "missing_body": "Не удалось найти эти покупки в вашем аккаунте. Вернитесь в «Покупки».",
      "pending": "Изменения на телефоне. Отправим, когда появится связь.",
      "no_purchases": "Здесь пока нет покупок. Забытое можно добавить сейчас.",
      "rejected_title": "Изменение не принято",
      "rejected_body": "Покупки остаются на телефоне. В «Покупках» можно посмотреть причину отказа и исправить покупку.",
      "review": "Разобраться с отказом"
    },
    "manual_meta": "Записываете вручную · {when}",
    "manual_since": "{day}, с {time}"
  },
  "purchases": {
    "title": "Покупки",
    "manual": "Записать покупки",
    "open_manual_meta": "{count} · записываете вручную",
    "continue": "Продолжить",
    "group_recorded": "Записаны",
    "recorded": "{count} · {day}",
    "empty": {
      "title": "Здесь будут ваши покупки",
      "body": "Запишите, что взяли и почём, — кнопка внизу. Дома оцените покупки, и «Что брать» подскажет, что брать снова."
    },
    "error": {
      "title": "Покупки не загрузились",
      "body": "Записать новые можно и так — кнопка внизу"
    },
    "manual_ask": {
      "title": "Уже записываете «{place}»",
      "body": "Открытая запись бывает одна. Продолжите эту — или закончите её и начните новую.",
      "continue": "Продолжить «{place}»",
      "finish": "Закончить и начать новую"
    },
    "capture": "Сфотографировать чек",
    "manual_by_hand": "Записать вручную",
    "group_working": "Разбираем",
    "group_review": "Посмотреть и записать",
    "receipt_from": "Чек от {day}, {time}",
    "waiting": "{parts} · ждёт связи",
    "sending": "{parts} · отправляем",
    "parsing_unknown": "разбираем · место узнаем из чека",
    "parsing_known": "{day}, {time} · читаем строки…",
    "issues_check": "проверьте {n} строку | проверьте {n} строки | проверьте {n} строк",
    "failed_meta": "не удалось прочитать",
    "reshoot_meta": "строк не нашли — переснимите",
    "no_items_meta": "без товаров · {day}",
    "recording_meta": "запишем, когда появится связь",
    "rejected_title": "Фото от {day}, {time}",
    "rejected_meta": "Не принят: {reason}",
    "remove": "Убрать",
    "reasons": {
      "not_photo": "на фото не видно чека",
      "too_large": "фото слишком большое",
      "lost": "фото не сохранилось на телефоне",
      "other": "сервер не принял чек",
      "link": "ссылка не подошла"
    },
    "recorded_receipt": "{count} · {day} · из чека",
    "recorded_sum": "сумма по чеку · {day}",
    "queued": {
      "waiting": "Фото на телефоне. Отправим сами, когда появится связь, — ничего делать не нужно.",
      "parsing": "Разбор идёт — приложение можно закрыть. Готовый чек встанет в «Посмотреть и записать».",
      "sending": "Фото уходят на сервер. Если закрыть приложение, отправка продолжится при следующем открытии.",
      "stuck": "Сервер получил не все части этого чека, а на этом телефоне их нет. Удалите чек и снимите заново.",
      "rejected": "Сервер не принял этот чек: {reason}. Уберите его и снимите заново.",
      "link_waiting": "Ссылка на телефоне. Отправим сами, когда появится связь, — ничего делать не нужно.",
      "link_sending": "Ссылка уходит на сервер. Если закрыть приложение, отправка продолжится при следующем открытии.",
      "link_parsing": "Спрашиваем налоговую Сербии. Чек, пробитый только что, она показывает через пару минут, — приложение можно закрыть. Готовый чек встанет в «Посмотреть и записать».",
      "link_rejected": "Сервер не принял этот чек: {reason}. Уберите его и снимите QR или вставьте ссылку заново."
    },
    "delete": "Удалить чек",
    "delete_note": "Удалим вместе с фото",
    "deleted": "Чек удалён вместе с фото",
    "empty_capture": {
      "body": "Сфотографируйте чек — строки прочитаем сами, вы проверите и запишете одной кнопкой. Без чека — «Записать вручную»."
    },
    "error_capture": "Снять чек или записать вручную можно и так",
    "stale": "Без связи · покупки на {when}",
    "stale_untimed": "Без связи · покупки из памяти телефона",
    "stale_error": "Сервер не ответил · покупки на {when}",
    "stale_error_untimed": "Сервер не ответил · покупки из памяти телефона",
    "earlier_online": "Раньше {day} — со связью",
    "offline": {
      "title": "Без связи",
      "body": "Покажем покупки, как только появится связь. Записать новые можно и сейчас — кнопка внизу"
    },
    "offline_capture": "Покажем покупки, как только появится связь. Снять чек или записать вручную можно и сейчас",
    "receipts_error": {
      "title": "Чеки не загрузились",
      "body": "Покажем, когда сервер ответит"
    },
    "receipts_offline": "Покажем чеки, как только появится связь",
    "stuck_meta": "{parts} · не все части дошли",
    "record_refused": "не записали — откройте и поправьте",
    "capture_link": "Чек по ссылке",
    "by_link": "по ссылке",
    "asking_tax_office": "спрашиваем налоговую",
    "missing_meta": "налоговая не показала чек",
    "invalid_meta": "налоговая не признаёт чек",
    "delete_note_link": "Удалим чек вместе со ссылкой"
  },
  "item": {
    "search_title": "Что взяли?",
    "search_placeholder": "Молоко, matsun, сыр…",
    "search_hint": "Можно с опечатками и латиницей",
    "group_here_last": "Брали здесь в прошлый раз",
    "group_recent": "Часто берёте",
    "group_found": "Нашли",
    "group_similar": "Похоже по написанию",
    "results_announced": "Нашли {n} позицию | Нашли {n} позиции | Нашли {n} позиций",
    "far_announced": "Не нашли «{query}». Похожа по написанию {n} позиция | Не нашли «{query}». Похожи по написанию {n} позиции | Не нашли «{query}». Похожи по написанию {n} позиций",
    "quantity": "Сколько",
    "unit": "Единица",
    "unit_kg": "кг",
    "unit_g": "г",
    "unit_l": "л",
    "unit_ml": "мл",
    "unit_piece": "шт",
    "price": "Цена как на ценнике",
    "currency": "Валюта цены",
    "unit_price_label": "За единицу",
    "unit_price_pending": "Считается само, вводить не надо",
    "unit_price_value": "{amount}/{unit}",
    "unit_price_announced": "За единицу: {value}",
    "cheaper": {
      "best": "Дешевле всего брали в {place} — {price}, {day}",
      "best_here": "Здесь брали по {price} — {day}",
      "there": "В {place} брали по {price} — {day}",
      "there_here": "Здесь же брали по {price} — {day}",
      "same": "Как в {place} — {price}, {day}",
      "same_here": "Как здесь {day} — {price}",
      "cheaper": "Тут дешевле — в {place} было {price}, {day}",
      "cheaper_here": "Дешевле, чем здесь {day} — было {price}",
      "alternative": "{name} — {price} в {place}, {day} · оценка {rating}"
    },
    "save": "Записать",
    "save_edit": "Сохранить",
    "delete": "Удалить позицию",
    "cancel": "Отменить",
    "offline_note": "Сохранится на телефоне, отправим со связью",
    "no_trip": {
      "body": "Сначала начните запись: покупке нужно место",
      "action": "К покупкам"
    },
    "empty": {
      "title": "Не нашли «{query}»",
      "text": "Добавим в справочник — напишите, как это называется на ценнике",
      "action": "Предложить товар"
    },
    "not_listed": "Нет нужного? Предложить товар",
    "propose": {
      "title": "Новый товар",
      "name": "Как написано на ценнике",
      "note": "Чем отличается на полке — необязательно",
      "submit": "Добавить в справочник",
      "offline": "Предложить можно со связью",
      "needs_name": "Напишите название",
      "needs_unit": "Выберите единицу",
      "sending": "Добавляем…",
      "name_invalid": "В названии есть знак, который справочник не примет, — наберите название заново",
      "note_invalid": "В пометке есть знак, который справочник не примет, — наберите пометку заново",
      "failed": "Не получилось добавить. Попробуйте ещё раз",
      "code": "Код {code} запишется к товару",
      "hint_source": "По данным Open Food Facts ↗",
      "size": "В упаковке {amount} {unit}",
      "size_drop": "Не указывать, сколько в упаковке",
      "taken": "Этот код уже у «{name}»",
      "take": "Взять «{name}»",
      "name_taken": "«{name}» уже есть — назовите товар иначе, например с маркой"
    },
    "error": {
      "title": "Сервер не ответил",
      "body": "Справочник сейчас не отвечает. Повторите — или возьмите товар из недавних",
      "body_alone": "Справочник сейчас не отвечает — повторите чуть позже",
      "fallback": "Взять из недавних",
      "fallback_note": "Пока — из ваших недавних позиций"
    },
    "offline": {
      "body": "Ищем только среди ваших недавних позиций. Полный справочник вернётся со связью",
      "strip": "Без связи · ищем только среди ваших недавних позиций. Полный справочник вернётся со связью"
    },
    "barcode": {
      "scan": "Сканировать штрихкод",
      "missing": "Код {code} справочнику не знаком",
      "missing_hint": "Или найдите его по названию",
      "hint": "Похоже, это «{name}»",
      "hint_size": "Похоже, это «{name}», {amount} {unit}",
      "hint_source": "по данным Open Food Facts",
      "error_body": "Не получилось проверить код {code}. Повторите — или найдите товар по названию",
      "offline_body": "Среди ваших недавних позиций этого кода нет. Найдите товар по названию — или отсканируйте со связью",
      "offline_strip": "Без связи · ищем только среди ваших недавних позиций",
      "found": "По коду {code} нашлось",
      "found_announced": "По коду {code} нашлось: {name}",
      "pending": "Код {code} ждёт позицию — выберите её в списке",
      "pending_drop": "Не привязывать код",
      "bind_question": "Привязать код {code} к «{name}»?",
      "bind_hint": "Все, кто отсканирует этот код, увидят эту позицию",
      "bind": "Привязать и записать",
      "bind_busy": "Привязываем…",
      "without_code": "Записать без кода",
      "propose_other": "Это другой товар — предложить",
      "taken": "Код {code} уже у «{name}»",
      "without_code_named": "Записать «{name}» без кода",
      "bind_offline_strip": "Без связи · код не привязан. Повторите со связью — или запишите без кода",
      "bind_error_body": "Не получилось привязать код {code}. Повторите — или запишите без кода",
      "not_this": "Код {code} — не этот товар?",
      "not_this_failed": "Не получилось отвязать код — проверьте связь",
      "in_store": "Код {code} — этикетка магазина",
      "in_store_body": "Её печатают весы или сам магазин: у другого пакета другой код. Найдите товар по названию",
      "detach_question": "Отвязать код {code} от «{name}»?",
      "detach_hint": "Его перестанут находить все",
      "detach": "Отвязать",
      "detach_busy": "Отвязываем…",
      "bind_named": "«{name}» уже есть в справочнике. Привязать код {code} к нему?"
    }
  },
  "sheet": {
    "close": "Закрыть"
  },
  "advice": {
    "title": "Что брать",
    "own_data_only": "Пока только ваши оценки",
    "shared_data": "Средние оценки всех, кто оценил",
    "shared_note": "Отзывы и цены — только ваши",
    "group_take": "Брать",
    "group_if_cheap": "Только если дёшево",
    "group_never": "Не брать нигде",
    "badge_take": "БРАТЬ",
    "badge_if_cheap": "ЕСЛИ ДЁШЕВО",
    "badge_never": "НЕ БРАТЬ",
    "cheapest_at": "Дешевле всего: {place}",
    "bought_at": "Брали здесь: {place}",
    "also_at": "Ещё: {places}",
    "also_place": "{place} {price}",
    "threshold": "Стоит брать дешевле {price}",
    "price_at": "{price} · {place}",
    "no_price_shown": "Цены нет намеренно: сравнивать нечего",
    "rating": "{value} из 5",
    "ratings_count": "{n} оценка | {n} оценки | {n} оценок",
    "rating_line": "{rating} · {count}",
    "truncated": "Показаны {shown} из {total}",
    "stale": "Без связи · список на {when}",
    "stale_error": "Сервер не ответил — список на {when}",
    "stale_loading": "Обновляем · список на {when}",
    "edit_action": "Изменить оценку",
    "edit": {
      "meta": "Меняется только ваша оценка",
      "meta_new": "Вы эту позицию не оценивали",
      "save_new": "Поставить оценку",
      "keeps_score": "Оценка останется прежней. Чтобы убрать её, снимите оценку",
      "withdraw": "Снять оценку",
      "withdrawing": "Снимаем оценку…",
      "withdraw_hint": "Позиция уйдёт отсюда, а покупка вернётся в «Оценки»",
      "withdraw_hint_shared": "Ваша оценка уйдёт из общей средней, а покупка вернётся в «Оценки»",
      "not_mine": "Вашей оценки здесь нет — обновите список",
      "nothing_changed": "Ничего не изменилось",
      "failed": "Не получилось сохранить. Попробуйте ещё раз",
      "offline": "Оценку можно изменить со связью"
    },
    "error": {
      "title": "Сервер не ответил",
      "body": "Список не загрузился. Попробуйте ещё раз",
      "body_capture": "Список не загрузился. Сфотографировать чек можно и так"
    },
    "offline": {
      "title": "Список появится со связью",
      "body": "Покажем список, как только появится связь. Записать покупки можно и сейчас",
      "body_capture": "Покажем список, как только появится связь. Сфотографировать чек можно и сейчас"
    },
    "city_reloading": "Обновляем · список для {city}",
    "stale_other_city": "Без связи · список для {oldCity} на {when}. Цены для {city} появятся со связью",
    "cities_genitive": {
      "Гюмри": "Гюмри",
      "Ереван": "Еревана",
      "Тбилиси": "Тбилиси",
      "Батуми": "Батуми",
      "Белград": "Белграда",
      "Нови-Сад": "Нови-Сада"
    },
    "search": {
      "label": "Поиск по справочнику",
      "placeholder": "Молоко, лаваш, сыр…",
      "group_unrated": "Ещё не оценивали",
      "rate": "Оценить",
      "empty": {
        "title": "Не нашли «{query}»",
        "body": "Такого товара в справочнике пока нет. Проверьте написание — можно латиницей и с опечатками",
        "body_offline": "Без связи ищем только среди оценённого. Весь справочник — со связью"
      },
      "error_body": "Не получилось поискать. Повторите — или очистите поле: список на месте",
      "offline": "Без связи · ищем только в списке на {when}",
      "offline_more": "Неоценённое и весь справочник найдём, когда появится связь"
    },
    "home": {
      "new": {
        "title": "Запишите первые покупки",
        "body": "{app} запомнит, что и почём вы взяли. А по вашим оценкам подскажет у полки, что брать снова и где дешевле."
      },
      "pending": {
        "title": "Осталось оценить",
        "body": "Покупки записаны. Оцените их дома — и здесь появится, что брать снова и где дешевле."
      },
      "next": "Что будет дальше",
      "step_purchases_title": "В магазине — «Покупки»",
      "step_purchases_body": "Что взяли и почём — цену за литр и килограмм посчитаем сами",
      "step_verdicts_title": "Дома — «Оценки»",
      "step_verdicts_body": "Поставьте каждой покупке от 1 до 5",
      "step_advice_title": "Здесь — «Что брать»",
      "step_advice_body": "Что брать снова, только если дёшево, не брать нигде — и где дешевле",
      "trust": "Свои оценки и цены — бесплатно, чужие — по доступу. Рекламы и платных мест здесь нет и не будет.",
      "new_capture": {
        "title": "Сфотографируйте первый чек",
        "body": "{app} прочитает и переведёт — вы проверите и запишете. А по вашим оценкам подскажет у полки, что брать снова и где дешевле."
      },
      "parsing": {
        "title": "Первый чек разбираем",
        "body": "Разбор идёт — приложение можно закрыть. Чек появится в «Покупках»: там его проверите и запишете."
      },
      "step_purchases_capture_title": "Проверите в «Покупках»",
      "step_purchases_capture_body": "Строки чека прочитаем сами — вы проверите и запишете одной кнопкой",
      "manual_body": "Без чека — на рынке или если чек потерялся"
    }
  },
  "verdict": {
    "title": "Оценки",
    "pending_count": "{n} покупка ждёт оценки | {n} покупки ждут оценки | {n} покупок ждут оценки",
    "context": "{when} · {place}",
    "question_tail": "как вам?",
    "current": "Ваша оценка: {n}",
    "scale_low": "Плохо",
    "scale_high": "Отлично",
    "scale_label": "Оценка {n} из 5",
    "scale_group": "Оценка",
    "review_label": "Пара слов — если есть что сказать",
    "review_placeholder": "Пахнет крахмалом, а не мясом",
    "review_unsupported": "В отзыве есть знак, который нельзя сохранить",
    "save": "Сохранить оценку",
    "save_disabled": "Выберите оценку",
    "skip": "Не сейчас",
    "footnote": "Оценка — отдельно от покупки: напоминание приходит на следующий день, у кассы это никому не нужно",
    "none": {
      "title": "Оценивать пока нечего",
      "body": "Сначала запишите покупку — здесь спросим, как вам",
      "action": "К покупкам"
    },
    "empty": {
      "title": "Всё оценено",
      "body": "Спасибо — база стала точнее. Напомним, когда появится новая покупка",
      "action": "Открыть «Что брать»"
    },
    "error": {
      "title": "Оценка не ушла",
      "body": "Черновик сохранён, попробуем отправить ещё раз"
    },
    "offline": {
      "title": "Оценка сохранена",
      "body": "Уйдёт сама, как только появится связь. Можно закрыть приложение",
      "strip": "Без связи · оценка сохранена на телефоне и уйдёт сама"
    },
    "stale": "Список на {when} — обновим, когда появится связь",
    "stale_error": "Список на {when} — сервер не ответил",
    "load_error": {
      "title": "Список покупок не загрузился",
      "body": "Сервер не ответил. Сохранённые оценки на телефоне целы"
    },
    "load_offline": {
      "title": "Список покупок появится со связью",
      "body": "Сохранённые оценки на телефоне целы и уйдут сами"
    },
    "returned": "Оценка «{name}» не принята — вернём её следующей",
    "sending": "Отправляем оценку…",
    "checking": "Проверяем, что ещё ждёт оценки…"
  },
  "money": {
    "approx": "≈ {amount}",
    "converted_package": "≈ {amount} за упаковку",
    "converted_note": "пересчёт приблизительный, сравниваем всегда по цене на ценнике",
    "rate_official": "курс {rate} · ЦБ РА",
    "rate_frozen": "Курс сохраняется вместе с записью покупок. Прошлый месяц не меняется от сегодняшнего курса",
    "rate_label": "1 {currency} =",
    "source_mine": "мой",
    "source_official": "официальный",
    "home_currency": "Моя валюта"
  },
  "spending": {
    "title": "Деньги",
    "subtitle": "Видите только вы",
    "month_prev": "Предыдущий месяц",
    "month_next": "Следующий месяц",
    "year_prev": "Предыдущий год",
    "year_next": "Следующий год",
    "spent": "Потрачено",
    "vs_previous": "{percent} к {month}",
    "vs_same_day": "{change} к тому же дню {month}",
    "month_started": "Месяц только начался",
    "month_to": {
      "01": "январю",
      "02": "февралю",
      "03": "марту",
      "04": "апрелю",
      "05": "маю",
      "06": "июню",
      "07": "июлю",
      "08": "августу",
      "09": "сентябрю",
      "10": "октябрю",
      "11": "ноябрю",
      "12": "декабрю"
    },
    "month_of": {
      "01": "января",
      "02": "февраля",
      "03": "марта",
      "04": "апреля",
      "05": "мая",
      "06": "июня",
      "07": "июля",
      "08": "августа",
      "09": "сентября",
      "10": "октября",
      "11": "ноября",
      "12": "декабря"
    },
    "foreign_part": "Включая {amount} (≈ {counted})",
    "uncounted": "Не посчитано: {amounts} — курса того дня нет",
    "unsent": "Ещё не учтено: {n} трата отправляется | Ещё не учтено: {n} траты отправляются | Ещё не учтено: {n} трат отправляются",
    "income": "Пришло",
    "income_uncounted": "и {amounts} не посчитано",
    "income_shifted_in": "с зарплатой {days}",
    "income_shifted_out": "зарплата {days} — в следующем месяце",
    "rest_spendable": "без сбережений ≈ {amount}",
    "rest_uncounted": "не посчитано: {accounts}",
    "rest_operations": "{n} операция не посчитана | {n} операции не посчитаны | {n} операций не посчитано",
    "rest_from": "Счета начинаются {day}",
    "rest_add": "Завести счёт",
    "rest_removed": "Счета убраны — вернуть",
    "rate_live_mine": "По моему курсу {rate} на сегодня",
    "rate_live_official": "По курсу {bank} {rate} на сегодня",
    "rate_live_fallback": "По курсу {rate} на сегодня — не от {bank}: он молчит больше недели",
    "rate_frozen": "По курсу на {date}: {rate}. Прошлые месяцы не пересчитываем",
    "rate_none": "Курса для пересчёта пока нет",
    "rate_value": "{amount} за 1 {sign}",
    "categories_title": "Куда ушли",
    "summary": {
      "charts": "Графики",
      "accounts_now": "На счетах сейчас",
      "accounts_spendable": "можно тратить ≈ {amount}",
      "accounts_count": "{n} счёт | {n} счёта | {n} счетов",
      "accounts_now_label": "Счета: на счетах сейчас ≈ {amount}, можно тратить ≈ {spendable}",
      "accounts_then": "На счетах на {when}",
      "accounts_then_label": "Счета: на счетах на {when} ≈ {amount}, можно тратить ≈ {spendable}",
      "donut_more": "Ещё {n} сектор — в «Графиках» | Ещё {n} сектора — в «Графиках» | Ещё {n} секторов — в «Графиках»",
      "donut_label": "Куда ушли: {list}. Открыть графики",
      "donut_later": "Доли появятся, когда месяц обновится",
      "donut_uncounted": "Доли появятся, когда у трат будет курс",
      "donut_empty": "В {month} трат пока нет",
      "donut_empty_body": "Доли появятся с первой тратой. Год — в «Графиках»",
      "donut_pending": "Первая трата {month} отправляется",
      "donut_pending_body": "Доли появятся, когда она дойдёт. Год — в «Графиках»",
      "donut_empty_label": "Куда ушли: в {month} трат пока нет. Открыть графики",
      "add": "Добавить трату",
      "offline_strip": "Без связи · цифры на {when}. Новые траты сохранятся на телефоне",
      "refused": "Не принята {n} трата | Не приняты {n} траты | Не приняты {n} трат",
      "refused_body": "Сервер не принял — исправить или убрать можно на «Тратах»",
      "refused_open": "Открыть «Траты»"
    },
    "charts": {
      "title": "Графики",
      "spent_title": "Расходы по месяцам",
      "spent_hint": "Коснитесь столбца или проведите пальцем по графику. Каждый месяц — по курсу того месяца",
      "bar_label": "{month}, {amount}",
      "income_title": "Пришло и ушло",
      "spent_legend": "Ушло",
      "difference": "Разница · {month}",
      "pair_label": "{month}: пришло {income}, ушло {spent}",
      "income_only": "Всё в {currency} — валюте дохода",
      "currency_in": {
        "AMD": "драмах",
        "RUB": "рублях",
        "USD": "долларах",
        "EUR": "евро",
        "GEL": "лари",
        "RSD": "динарах"
      },
      "no_rate": "нет курса месяца",
      "difference_uncounted": "не всё посчитано",
      "income_uncounted": "Пришло, не посчитано: {amounts}",
      "spent_uncounted": "Ушло, не посчитано: {amounts}",
      "uncounted": "не посчитано: {amounts}",
      "category_average": "в среднем {amount}",
      "category_missing": "Этой категории на графиках нет — показаны «{name}»",
      "empty": {
        "title": "Графики появятся с первыми тратами",
        "body": "Нужен хотя бы один месяц трат или доходов. Покупки из магазина попадут сюда сами"
      },
      "load_error": {
        "title": "Не удалось загрузить графики",
        "body": "Сервер не ответил. Траты и доходы не пропали — попробуйте ещё раз"
      },
      "error_strip": "Сервер не ответил — графики на {when}",
      "offline": {
        "strip": "Без связи · графики на {when}",
        "body": "Графики появятся, когда интернет вернётся"
      },
      "rest": "Остальные",
      "mode": "Период",
      "mode_month": "Месяц",
      "mode_year": "Год",
      "year_center": "{year} · {n} месяц | {year} · {n} месяца | {year} · {n} месяцев",
      "year_rate_note": "Каждый месяц — по курсу того месяца",
      "year_no_rate_one": "нет курса за {month}",
      "year_no_rate_many": "нет курса за {n} месяц | нет курса за {n} месяца | нет курса за {n} месяцев",
      "year_change": "{change} к среднему",
      "year_change_running": "{change} к обычному к {day}",
      "year_avg": "В среднем {amount} за {from} — {to}",
      "year_avg_running": "В среднем {amount} за {from} — {to}, без идущего месяца",
      "year_avg_few": "Среднее появится после {month}: нужно три закрытых месяца",
      "year_avg_short": "Для среднего мало закрытых месяцев: {n} из 3",
      "year_avg_uncounted": "Среднее не посчитать: в каждом закрытом месяце есть траты без курса",
      "year_avg_beyond": "Среднее не посчитать: суммы за месяцы больше, чем помещается в расчёт",
      "year_flow_note": "За {year} год разница {amount}. Всё в {currency} — валюте дохода",
      "year_flow_missing": "Разницу за {year} год не посчитать: не всё пересчитано — {months}. Всё в {currency} — валюте дохода",
      "category_months_title": "Категория по месяцам",
      "category_avg": "Пунктир — среднее по закрытым месяцам",
      "center_running": "{month} · идёт",
      "center_share": "{share} · ≈ {amount}",
      "rest_names": "В «Остальных» — {names}",
      "donut_order": "Сектора идут по часовой стрелке от верха, в порядке списка",
      "vs_usual_title": "Против обычного",
      "vs_usual_note": "{month} против среднего за {from} — {to}. Порядок — по разнице в {sign}",
      "vs_usual_note_running": "{month} на сегодня против среднего за {from} — {to}. Порядок — по разнице в {sign}",
      "vs_usual_meta": "{amount} · обычно {average}",
      "vs_usual_new": "новая",
      "vs_usual_legend": "Черта — обычный месяц категории",
      "vs_usual_spoken": "{name}: {amount}, обычно {average}, {change}",
      "few_title": "Сравнение — с {month}",
      "few_body_none": "Обычный месяц — среднее закрытых месяцев до выбранного, от трёх до двенадцати. До {month} закрытых месяцев нет.",
      "few_body_one": "Обычный месяц — среднее закрытых месяцев до выбранного, от трёх до двенадцати. До {month} закрыт только {closed}.",
      "few_body_many": "Обычный месяц — среднее закрытых месяцев до выбранного, от трёх до двенадцати. До {month} закрыты только {closed}.",
      "pace_title": "Темп месяца",
      "pace_usual": "Обычный",
      "pace_day": "К {date}",
      "pace_today": "К {date} · сегодня",
      "pace_sub": "обычно к этому дню {amount} · {change}",
      "pace_sub_plain": "обычно к этому дню {amount}",
      "pace_note": "Нарастающим итогом по дням. Пунктир — обычный месяц: среднее закрытых месяцев.",
      "pace_move": "Ведите ползунок — покажем день",
      "pace_few": "Пунктир обычного месяца — с {month}.",
      "pace_spoken": "{date}: {amount}, обычно {average}",
      "pace_spoken_few": "{date}: {amount}",
      "few_title_none": "Для этого месяца сравнения нет",
      "pace_few_none": "Обычного месяца для этого месяца нет.",
      "pace_uncounted": "Пунктира нет: в каждом закрытом месяце есть траты без курса."
    },
    "share_tiny": "<1 %",
    "categories_link": "Категории",
    "day_today": "Сегодня · {date}",
    "day_yesterday": "Вчера · {date}",
    "row_open": "Открыть трату:",
    "row_open_trip": "Открыть покупки:",
    "trip_row_title": "Покупки в «{place}»",
    "trip_row_meta": "{category} · {n} позиция | {category} · {n} позиции | {category} · {n} позиций",
    "trip_row_sum": "{category} · сумма по чеку",
    "uncounted_row": "не посчитано",
    "more": "И ещё {n} трата за {range} | И ещё {n} траты за {range} | И ещё {n} трат за {range}",
    "more_retry": "Загрузить остальные",
    "month_empty": "В этом месяце трат нет",
    "pending": "Отправляем…",
    "editing": "Правка отправляется",
    "refused": "Не принята",
    "removed": "Удалено: {title} · {amount}",
    "removed_announced": "Удалено: {title} · {amount}. Вернуть — 10 секунд",
    "restore": "Вернуть",
    "restored": "Трата возвращена",
    "saved_offline": "Трата сохранена на телефоне, отправим позже",
    "empty": {
      "title": "Добавьте первую трату",
      "body": "Барбер, аренда, кафе, такси — всё, что не в магазине. Записанные покупки попадут сюда сами"
    },
    "load_error": {
      "title": "Не удалось загрузить траты",
      "body": "Сервер не ответил. Сохранённые траты не пропали — попробуйте ещё раз"
    },
    "offline": {
      "title": "Нет связи",
      "body": "Траты появятся, когда интернет вернётся. Новую трату можно записать и сейчас",
      "body_read": "Траты появятся, когда интернет вернётся"
    },
    "error_strip": "Сервер не ответил — траты на {when}",
    "rejected_other": {
      "title": "Сервер не принял действие",
      "unknown": "Сервер ответил: {code}"
    },
    "category": {
      "groceries": "Продукты",
      "cafe": "Кафе и рестораны",
      "rent": "Аренда жилья",
      "home": "Дом и быт",
      "beauty": "Красота и гигиена",
      "transport": "Транспорт",
      "telecom": "Связь и интернет",
      "health": "Здоровье",
      "clothes": "Одежда",
      "pets": "Животные",
      "leisure": "Развлечения",
      "documents": "Документы",
      "other": "Прочее"
    },
    "icon": {
      "tag": "Бирка",
      "gift": "Подарок",
      "sport": "Спорт",
      "study": "Учёба",
      "kids": "Дети",
      "taxi": "Такси",
      "car": "Машина",
      "fuel": "Топливо",
      "travel": "Путешествия",
      "coffee": "Кофе",
      "bar": "Бар",
      "games": "Игры",
      "books": "Книги",
      "music": "Музыка",
      "phone": "Телефон",
      "tech": "Техника",
      "repair": "Ремонт",
      "flowers": "Цветы",
      "charity": "Благотворительность",
      "subscriptions": "Подписки",
      "bank": "Банк и налоги",
      "languages": "Языки",
      "dentist": "Стоматолог",
      "utilities": "Коммуналка"
    },
    "currency_name": {
      "AMD": "Драмы",
      "RUB": "Рубли",
      "USD": "Доллары",
      "EUR": "Евро",
      "GEL": "Лари",
      "RSD": "Динары"
    },
    "sheet": {
      "title_add": "Новая трата",
      "title_edit": "Трата",
      "meta_edit": "Добавлена вручную · {date}",
      "amount": "Сумма",
      "amount_placeholder": "0",
      "currency": "Валюта в шторке траты",
      "conversion_mine": "≈ {amount} по моему курсу {rate}",
      "conversion_official": "≈ {amount} по курсу {bank} {rate}",
      "conversion_fallback": "≈ {amount} по курсу {rate}, не от {bank}",
      "conversion_later": "Посчитаем по курсу дня траты",
      "conversion_counted": "≈ {amount} по курсу дня траты",
      "category": "Категория",
      "add_category": "Своя",
      "more": "Ещё…",
      "more_title": "Категория",
      "date": "Когда",
      "date_today": "Сегодня, {date}",
      "date_yesterday": "Вчера, {date}",
      "note": "Что это",
      "note_placeholder": "Барбер, домен, такси",
      "place": "Где",
      "place_placeholder": "Кафе, сервис, сайт",
      "optional": "· необязательно",
      "details_title": "Дата, заметка, место",
      "details_none": "без заметки",
      "details_label": "Дата, заметка, место: {value}",
      "details_done": "Готово",
      "shop_title": "Это покупка в магазине?",
      "shop_body": "Запишите её в «Покупках» — товар попадёт в справочник и оценки, а трата сюда сама",
      "shop_action": "Покупки ›",
      "bad_amount": "Введите сумму больше нуля",
      "bad_category": "Выберите категорию",
      "bad_day": "Выберите день не позже сегодняшнего",
      "bad_text": "Здесь есть знаки, которые не сохранить",
      "offline": "Нет связи. Сохраним на телефоне и отправим, когда интернет вернётся",
      "save": "Сохранить трату",
      "refused": "Сервер не принял трату: {reason}. Исправьте и сохраните ещё раз",
      "refused_conflict": "Трату изменили на другом устройстве. Здесь то, что ввели вы, — сохраните ещё раз поверх",
      "dismiss": "Убрать",
      "remove": "Удалить трату",
      "trip_meta": "{date} · {n} позиция | {date} · {n} позиции | {date} · {n} позиций",
      "trip_note": "Эта трата пришла из «Покупок» и правится там — вместе с ценами и оценками товаров",
      "trip_open": "Открыть в «Покупках»",
      "trip_items_offline": "Позиции появятся, когда вернётся связь",
      "trip_items_error": "Не удалось загрузить позиции"
    },
    "categories": {
      "title": "Категории",
      "presets": "Готовые",
      "own_group": "Свои",
      "archived": "Убранные",
      "remove": "Убрать",
      "remove_label": "Убрать категорию «{name}»",
      "restore_label": "Вернуть категорию «{name}»",
      "add": "Добавить категорию",
      "note": "Убранная категория пропадает из выбора, но остаётся у своих трат и в прошлых месяцах",
      "load_error": {
        "title": "Не удалось загрузить категории",
        "body": "Сервер не ответил. Попробуйте ещё раз"
      },
      "offline": {
        "title": "Нет связи",
        "body": "Категории появятся, когда интернет вернётся"
      }
    },
    "new_category": {
      "title": "Новая категория",
      "name": "Название",
      "placeholder": "Такси, спорт, подарки",
      "save": "Добавить",
      "bad_empty": "Введите название",
      "bad_taken": "Такая категория уже есть",
      "edit_title": "Категория",
      "icon": "Иконка",
      "colour": "Цвет",
      "colour_label": "Цвет {n} из {total}",
      "edit_save": "Сохранить",
      "remove": "Убрать категорию"
    },
    "entries_label": "Разделы «Денег»",
    "month_in": {
      "01": "январе",
      "02": "феврале",
      "03": "марте",
      "04": "апреле",
      "05": "мае",
      "06": "июне",
      "07": "июле",
      "08": "августе",
      "09": "сентябре",
      "10": "октябре",
      "11": "ноябре",
      "12": "декабре"
    },
    "rest_on": "На счетах {date}",
    "list": {
      "title": "Траты",
      "refused": "Не приняты",
      "refused_more": "И ещё {n} — отмечена в журнале ниже | И ещё {n} — отмечены в журнале ниже | И ещё {n} — отмечено в журнале ниже",
      "refused_below": "{n} отмечена в журнале ниже — показать | {n} отмечены в журнале ниже — показать | {n} отмечено в журнале ниже — показать",
      "count": "{n} трата | {n} траты | {n} трат",
      "unsent": "{n} ещё не учтена | {n} ещё не учтены | {n} ещё не учтено",
      "offline_strip": "Без связи · траты на {when}. Новые сохранятся на телефоне",
      "empty": {
        "title": "В {month} трат нет",
        "body": "Добавьте трату или запишите покупки в «Покупках» — они попадут сюда сами"
      }
    },
    "entry_value": "{name}, {value}"
  },
  "exchange": {
    "title": "Обмен денег",
    "my_rate": "Мой курс",
    "basis_weighted": "средний по остатку · с {date}",
    "basis_last": "по последнему обмену · с {date}",
    "basis_income": "по последнему поступлению · с {date}",
    "estimated": "часть — по курсу {bank} на дни обменов и поступлений: во сколько обошлись эти деньги, не записано",
    "base_since": "Считаем в {base} с {date} — прежние обмены в другой валюте в курс не входят и остаются как были",
    "cost_line": "{rate} · {basis}",
    "cost_line_estimated": "{rate} · {basis} · часть — по курсу {bank}",
    "no_wallet": "{quote} пока не приходили ни обменом, ни доходом — новые покупки считаются по курсу {bank}",
    "wallet_out_of_band": "Курс {quote} за {base} по вашим обменам выходит за пределы, которые хранит запись покупок, — проверьте суммы обменов. Новые покупки считаются по курсу {bank}",
    "wallet_unknown": "Курс неизвестен: обмен {given} → {quote} от {date} не с чем оценить — свежего курса {dayBank} на тот день нет. Новые покупки считаются по курсу {bank}, пока не запишете обмен с известной ценой или доход в день со свежим курсом {bank}",
    "wallet_old_reckoning": "Курс неизвестен: {quote}, купленные {date} за {given}, в {base} цены не имеют — после смены валюты пересчёта прежний счёт не пересчитывается. Новые покупки считаются по курсу {bank}, пока не запишете обмен за {base} или доход в {quote} после смены — в день со свежим курсом {bank}",
    "wallet_unknown_income": "Курс неизвестен: поступление {quote} от {date} не с чем оценить — свежего курса {bank} на тот день нет. Новые покупки считаются по курсу {bank}, пока не запишете обмен с известной ценой или доход в день со свежим курсом {bank}",
    "wallet_old_reckoning_income": "Курс неизвестен: {quote}, полученные {date}, в {base} цены не имеют — после смены валюты пересчёта прежний счёт не пересчитывается. Новые покупки считаются по курсу {bank}, пока не запишете обмен за {base} или доход в {quote} после смены — в день со свежим курсом {bank}",
    "preference_legend": "Новые покупки считаются",
    "preference_personal": "по моему курсу",
    "preference_official": "по курсу {bank}",
    "preference_hint": "Мой курс — из обменов и доходов; пока его нет, покупки всё равно посчитаются по {bank}",
    "record": "Записать обмен",
    "record_offline": "Записать обмен можно со связью",
    "error_strip": "Сервер не ответил — обмены на {when}",
    "list_title": "Обмены",
    "row_amounts": "{given} → {received}",
    "row_rate": "{date} · {rate}",
    "amended": "исправлен {date}",
    "amend_conflict": "Этот обмен уже исправили на другом устройстве — показываем, как он записан теперь. Если нужно, исправьте ещё раз",
    "amend_conflict_stale": "Этот обмен уже исправили на другом устройстве. Покажем, как он записан теперь, когда будет связь с сервером",
    "vanished": "Этого обмена больше нет — его удалили. Список обновлён",
    "vanished_stale": "Этого обмена больше нет — его удалили. Список обновим, когда будет связь с сервером",
    "remove_sheet": {
      "title": "Удалить обмен?",
      "body": "Удалённый обмен перестаёт учитываться в курсе новых покупок. Прошлые покупки не меняются",
      "confirm": "Удалить",
      "confirm_busy": "Удаляем…"
    },
    "removed": "Обмен удалён: {amounts}",
    "removed_announced": "Обмен удалён: {amounts}. Вернуть — 10 секунд",
    "restore": "Вернуть",
    "restoring": "Возвращаем…",
    "restore_offline": "Вернём, когда будет связь",
    "restored": "Обмен возвращён",
    "restore_gone": "Обмен уже нельзя вернуть — удаление стало окончательным. Если он был нужен, запишите его заново",
    "conflict": "Этот обмен уже записан — показываем, как он записан сейчас. Если суммы неверны, нажмите на него в списке и исправьте",
    "conflict_stale": "Этот обмен уже записан — не записывайте его заново. Покажем его, когда будет связь с сервером",
    "empty": {
      "title": "Обменов пока нет",
      "body": "Запишите, сколько отдали и сколько получили, — курс посчитаем сами. Пока своего курса нет, покупки считаются по курсу {bank}"
    },
    "offline": {
      "title": "Нет связи",
      "body": "Обмены покажем, когда связь вернётся",
      "strip": "Без связи · обмены на {when}. Записать обмен и поменять курс можно со связью",
      "strip_record": "Без связи · обмены на {when}. Записать обмен можно со связью"
    },
    "load_error": {
      "title": "Не удалось загрузить обмены",
      "body": "Сервер не ответил как надо. Попробуйте ещё раз"
    },
    "failed": "Не получилось. Проверьте связь и попробуйте ещё раз",
    "sheet": {
      "title": "Обмен",
      "title_amend": "Правка обмена",
      "meta": "Сколько отдали и сколько получили — курс посчитаем сами",
      "given": "Отдал",
      "received": "Получил",
      "currency": "Валюта",
      "same_currency": "Отдали и получили одну валюту — это не обмен",
      "day": "День обмена",
      "held": "Было {currency} до обмена",
      "held_hint": "Необязательно. С ним курс учтёт, по какой цене достались оставшиеся деньги; без него — возьмём курс этого обмена",
      "held_estimate": "По записанным тратам ≈ {amount}",
      "held_estimate_last": "Из последнего обмена по записанным тратам осталось ≈ {amount}",
      "held_estimate_last_income": "Из последнего поступления по записанным тратам осталось ≈ {amount}",
      "note": "Где и заметка",
      "note_placeholder": "Например, «ВТБ банкомат» или «по памяти»",
      "bad_note": "Здесь нечего сохранить — напишите хоть слово или оставьте поле пустым",
      "history": "Прежние версии",
      "version": "до {until}: {amounts} · {date}",
      "version_note": "до {until}: {amounts} · {date} · {note}",
      "save": "Сохранить обмен",
      "save_amend": "Сохранить правку",
      "save_offline": "Сохраним, когда будет связь",
      "remove": "Удалить обмен",
      "remove_offline": "Удалим, когда будет связь",
      "offline": "Без связи · исправить и удалить обмен можно со связью — введённое останется здесь",
      "offline_amend": "Без связи · исправить обмен можно со связью — введённое останется здесь",
      "unanswered": "Сервер не ответил",
      "amend_conflict": "Пока вы правили, этот обмен исправили на другом устройстве. Сейчас он записан так, как ниже; сохраните ещё раз, чтобы записать ваши суммы поверх",
      "amend_conflict_stale": "Пока вы правили, этот обмен исправили на другом устройстве. Как он записан теперь, покажем, когда будет связь с сервером",
      "current": "Сейчас записано: {details}",
      "current_held": "было до обмена {amount}",
      "saving": "Сохраняем обмен…",
      "bad_day": "Выберите день обмена",
      "channel": "Как меняли",
      "channel_none": "Не указано",
      "channel_bankCash": "Банк, нал",
      "channel_bankNoncash": "Безнал",
      "channel_exchanger": "Обменник"
    },
    "edit_on": "Исправить обмен от {date}:",
    "card_given": "Отдал",
    "card_received": "Получил",
    "card_rate": "Курс обмена",
    "card_official": "{source} на {date}",
    "card_source_cba": "ЦБ РА",
    "card_source_cbr": "ЦБ РФ",
    "card_source_erapi": "open.er-api.com",
    "card_source_nbg": "НБ Грузии",
    "card_source_nbs": "НБ Сербии",
    "card_more": "На {amount} больше, чем по ЦБ РА",
    "card_less": "На {amount} меньше, чем по ЦБ РА",
    "card_equal": "Ровно как по ЦБ РА",
    "card_more_other": "На {amount} больше, чем по курсу {source}",
    "card_less_other": "На {amount} меньше, чем по курсу {source}",
    "card_equal_other": "Ровно как по курсу {source}",
    "card_no_official": "Курса {bank} на этот день нет — сравнить не с чем",
    "card_no_official_short": "Курса {bank} на этот день нет",
    "card_doubtful": "Курс {bank} в тот день под сомнением — сравнивать не будем",
    "channel": {
      "bankCash": "Банки, наличные",
      "bankNoncash": "Банки, безнал",
      "banksAll": "Банки, все клиенты",
      "exchanger": "Обменники"
    },
    "market": {
      "title": "Курсы по данным ЦБ РА",
      "hint": "Средние курсы сделок банков и обменников с людьми за день. Лучший для вас отмечен звёздочкой",
      "official": "ЦБ РА на {date}: {rate}",
      "sell": "Продать",
      "buy": "Купить",
      "where": "Где меняли",
      "best_mark": "лучший",
      "row_date": "на {date}",
      "best": "Лучший курс {date}: {channel}",
      "own": "{channel} на {date}",
      "worse": "{amount} · хуже, чем {where}",
      "better": "{amount} · лучше, чем {where}",
      "equal": "Ровно как {where}",
      "where_bankCash": "в банках за наличные",
      "where_bankNoncash": "в банках безналом",
      "where_banksAll": "в банках (все клиенты)",
      "where_exchanger": "в обменниках",
      "pending": "Обменники за этот день ЦБ РА выложит позже — строка пересчитается сама"
    },
    "vs_market": {
      "title": "Обмены против рынка",
      "note": "За 12 месяцев, каждый обмен — против рынка своего дня по данным ЦБ РА: своего канала, если он назван, иначе лучшего курса. Минус — отдали больше, чем на рынке",
      "uncounted": "Без сравнения: {n} обмен — рынка или курса того дня нет | Без сравнения: {n} обмена — рынка или курса тех дней нет | Без сравнения: {n} обменов — рынка или курса тех дней нет",
      "count": "{n} обмен | {n} обмена | {n} обменов",
      "no_place": "Без места",
      "worse": "хуже рынка",
      "better": "лучше рынка",
      "count_word": "{count} · {word}"
    },
    "rate_chart": {
      "title": {
        "RUB": "Курс рубля за {period}",
        "USD": "Курс доллара за {period}",
        "EUR": "Курс евро за {period}"
      },
      "period": "Период",
      "period_option": {
        "1": "Месяц",
        "6": "6 месяцев",
        "12": "12 месяцев"
      },
      "period_in": {
        "1": "месяц",
        "6": "6 месяцев",
        "12": "12 месяцев"
      },
      "legend_market": "Рынок · все клиенты банков",
      "legend_mine": "Мои обмены",
      "pair": "Пара",
      "pair_option": "{currency} и {dram}",
      "week": "Неделя по {day} · рынок",
      "day": "{day} · рынок",
      "no_market": "Рынка за эту неделю нет",
      "no_market_day": "Рынка за этот день нет",
      "no_market_period": "Рынка за {period} нет",
      "mine": "Мой обмен {day} · {rate}",
      "diff": "{change} · {word}",
      "spoken_diff": "{change}, {word}",
      "mine_no_market": "Рынка того дня нет",
      "mine_no_rate": "Без сравнения: курса ЦБ РА того дня нет",
      "no_change": "без сравнения",
      "none": "Обменов на этой неделе не было",
      "none_day": "В этот день обменов не было",
      "none_period": "Обменов за {period} не было",
      "spoken_market": "рынок {rate}",
      "spoken_no_market": "рынка нет",
      "spoken": "Неделя по {day}: {market}",
      "spoken_day": "{day}: {market}",
      "spoken_mine": "Неделя по {day}: {market}; мой обмен {date}: {mine}, {change}",
      "spoken_mine_day": "{day}: {market}; мой обмен: {mine}, {change}",
      "note_week_bankBuys": "Линия — рынок: по скольку банки покупали валюту у всех клиентов в конце недели, по данным ЦБ РА. Точки — ваши обмены: выше линии — получили больше драмов. Черта ведёт к рынку, с которым сравнили обмен: вашего способа обмена или лучшему в тот день. Коснитесь графика — покажем неделю",
      "note_day_bankBuys": "Линия — рынок: по скольку банки покупали валюту у всех клиентов в тот день, по данным ЦБ РА; в выходные — курс пятницы. Точки — ваши обмены: выше линии — получили больше драмов. Черта ведёт к рынку, с которым сравнили обмен: вашего способа обмена или лучшему в тот день. Коснитесь графика — покажем день",
      "note_week_bankSells": "Линия — рынок: по скольку банки продавали валюту всем клиентам в конце недели, по данным ЦБ РА. Точки — ваши обмены: ниже линии — отдали меньше драмов. Черта ведёт к рынку, с которым сравнили обмен: вашего способа обмена или лучшему в тот день. Коснитесь графика — покажем неделю",
      "note_day_bankSells": "Линия — рынок: по скольку банки продавали валюту всем клиентам в тот день, по данным ЦБ РА; в выходные — курс пятницы. Точки — ваши обмены: ниже линии — отдали меньше драмов. Черта ведёт к рынку, с которым сравнили обмен: вашего способа обмена или лучшему в тот день. Коснитесь графика — покажем день"
    }
  },
  "income": {
    "title": "Доходы",
    "record": "Записать доход",
    "record_offline": "Записать доход можно со связью",
    "error_strip": "Сервер не ответил — доходы на {when}",
    "row_line": "{source} · {date}",
    "amended": "исправлен {date}",
    "remove_sheet": {
      "title": "Удалить доход?",
      "body": "Прошлые покупки не меняются. Если этот доход входил в ваш курс, новые покупки посчитаются без него",
      "confirm": "Удалить доход",
      "confirm_busy": "Удаляем доход…"
    },
    "removed": "Доход удалён: {amount}",
    "removed_announced": "Доход удалён: {amount}. Вернуть — 10 секунд",
    "restore": "Вернуть",
    "restoring": "Возвращаем…",
    "restore_offline": "Вернём, когда будет связь",
    "restored": "Доход возвращён",
    "restore_gone": "Доход уже нельзя вернуть — удаление стало окончательным. Если он был нужен, запишите его заново",
    "conflict": "Этот доход уже записан — показываем, как он записан сейчас. Если что-то неверно, нажмите на него в списке и исправьте",
    "conflict_stale": "Этот доход уже записан — не записывайте его заново. Покажем его, когда будет связь с сервером",
    "amend_conflict": "Этот доход уже исправили на другом устройстве — показываем, как он записан теперь. Если нужно, исправьте ещё раз",
    "amend_conflict_stale": "Этот доход уже исправили на другом устройстве. Покажем, как он записан теперь, когда будет связь с сервером",
    "vanished": "Этого дохода больше нет — его удалили. Список обновлён",
    "vanished_stale": "Этого дохода больше нет — его удалили. Список обновим, когда будет связь с сервером",
    "empty": {
      "title": "Доходов пока нет",
      "body": "Запишите, сколько и когда пришло, — суммы за месяц посчитаем сами. Доходы необязательны: покупки и оценки работают и без них"
    },
    "offline": {
      "title": "Нет связи",
      "body": "Доходы покажем, когда связь вернётся",
      "strip": "Без связи · доходы на {when}"
    },
    "load_error": {
      "title": "Не удалось загрузить доходы",
      "body": "Сервер не ответил как надо. Попробуйте ещё раз"
    },
    "failed": "Не получилось. Проверьте связь и попробуйте ещё раз",
    "source": {
      "salary": "Зарплата",
      "bonus": "Премия",
      "freelance": "Фриланс / подработка",
      "debt_return": "Возврат долга",
      "sale": "Продажа вещей",
      "gift": "Подарок / помощь",
      "interest": "Проценты по вкладу",
      "brought": "Привезённые деньги",
      "other": "Прочее"
    },
    "sheet": {
      "title": "Доход",
      "title_amend": "Правка дохода",
      "meta": "Сколько и когда пришло — в любой из четырёх валют",
      "amount": "Сумма",
      "currency": "Валюта",
      "bought_hint": "Купили эти деньги за {base}? Запишите это обменом — курс учтёт вашу цену",
      "source": "Откуда",
      "source_placeholder": "Выберите",
      "no_source": "Выберите, откуда пришли деньги",
      "day": "День поступления",
      "bad_day": "Выберите день поступления",
      "held": "Было {currency} до поступления",
      "held_hint": "Необязательно. С ним курс учтёт, по какой цене достались деньги, что уже были; без него — возьмём курс {bank} этого дня",
      "note": "Заметка",
      "note_placeholder": "Например, «за сентябрь»",
      "bad_note": "В заметке нечего сохранить — напишите хоть слово или оставьте поле пустым",
      "history": "Прежние версии",
      "version": "до {until}: {amount} · {source} · {date}",
      "version_note": "до {until}: {amount} · {source} · {date} · {note}",
      "save": "Сохранить доход",
      "save_amend": "Сохранить правку",
      "save_offline": "Сохраним, когда будет связь",
      "remove": "Удалить доход",
      "remove_offline": "Удалим, когда будет связь",
      "offline": "Без связи · исправить и удалить доход можно со связью — введённое останется здесь",
      "offline_amend": "Без связи · исправить доход можно со связью — введённое останется здесь",
      "unanswered": "Сервер не ответил",
      "saving": "Сохраняем доход…",
      "amend_conflict": "Пока вы правили, этот доход исправили на другом устройстве. Сейчас он записан так, как ниже; сохраните ещё раз, чтобы записать ваше поверх",
      "amend_conflict_stale": "Пока вы правили, этот доход исправили на другом устройстве. Как он записан теперь, покажем, когда будет связь с сервером",
      "current": "Сейчас записано: {details}",
      "current_held": "было до поступления {amount}"
    },
    "fab": "Доход",
    "edit_on": "Исправить доход от {date}:"
  },
  "devices": {
    "title": "Устройства",
    "list_title": "Где вы вошли",
    "this_device": "Это устройство",
    "unknown": "Неизвестное устройство",
    "meta_current": "Вошли {signedIn}",
    "meta": "Вошли {signedIn} · были {seen}",
    "end": "Завершить",
    "end_label": "Завершить вход на {device}",
    "end_label_unknown": "Завершить вход на неизвестном устройстве",
    "end_sheet": {
      "title": "Завершить вход на {device}?",
      "title_unknown": "Завершить вход на неизвестном устройстве?",
      "body": "На том устройстве Molvia попросит войти через Telegram заново. Вернуть этот вход отсюда нельзя.",
      "confirm": "Завершить вход",
      "confirm_busy": "Завершаем…"
    },
    "end_failed": "Не получилось завершить вход. Проверьте связь и попробуйте ещё раз.",
    "ended": "Вход на {device} завершён",
    "ended_unknown": "Вход на неизвестном устройстве завершён",
    "more": "Показаны последние {shown} из {total}",
    "note": "Завершённое устройство попросит войти заново при следующем открытии. То, что сохранено на нём самом, сервер стереть не может.",
    "load_error": {
      "title": "Список не загрузился",
      "body": "Сервер не ответил. Попробуйте ещё раз."
    },
    "offline": {
      "title": "Нет связи",
      "body": "Список устройств покажем, когда связь вернётся."
    }
  },
  "bot": {
    "title": "Бот в Telegram",
    "group_messages": "Сообщения",
    "blocked": "Бот заблокирован в Telegram, поэтому сообщения не приходят. Разблокируйте бота — и они вернутся.",
    "reminders": {
      "label": "Напоминать об оценке",
      "hint": "Вечером на следующий день после покупки бот спросит, как вам. Если не отвечать, будет спрашивать реже, а потом замолчит на полгода."
    },
    "receipts": {
      "label": "Сообщать, что чек разобран",
      "hint": "Если вы ушли с экрана, пока чек разбирался. В сообщении — магазин или дата чека и число позиций, без сумм и товаров."
    },
    "load_error": {
      "title": "Настройки бота не загрузились",
      "body": "Сервер не ответил. Попробуйте ещё раз."
    },
    "offline": {
      "title": "Нет связи",
      "body": "Настройки бота покажем, когда связь вернётся."
    }
  },
  "sign_out": {
    "title": "Выйти из Molvia на этом устройстве?",
    "body": "С этого устройства сотрётся всё, что Molvia на нём сохранила. На сервере ничего не пропадёт: войдите через Telegram — и всё вернётся.",
    "unsent": "{n} запись не отправлена или не принята — она пропадёт | {n} записи не отправлены или не приняты — они пропадут | {n} записей не отправлено или не принято — они пропадут",
    "confirm": "Выйти и стереть",
    "confirm_busy": "Выходим…",
    "offline": "Выйти можно только со связью: без неё вход на сервере не завершить.",
    "error": "Не получилось выйти: сервер не ответил. Попробуйте ещё раз."
  },
  "erase": {
    "title": "Удалить все ваши данные?",
    "goes": "Уйдёт всё, что Molvia о вас знает: покупки, траты и их категории, обмены денег, доходы, счета и сверки, оценки и отзывы, выбор в поиске, отметки о визитах, настройки и входы на всех устройствах.",
    "stays": "Товары, магазины и штрихкоды, которые вы добавили в общий справочник, и память магазинов — какой товар стоит за строкой чека и цена с полки — останутся без вашего имени. Останется и одно число — сколько человек, пришедших в ту же неделю, удалили свои данные.",
    "devices": "Сохранённое на этом устройстве сотрётся. На других копии останутся, пока там не удалить приложение или данные сайта.",
    "final": "Отменить это нельзя. Копию можно сначала скачать — «Скачать мои данные».",
    "confirm": "Удалить навсегда",
    "confirm_busy": "Удаляем…",
    "offline": "Удалить можно только со связью.",
    "error": "Не получилось удалить: сервер не ответил. Попробуйте ещё раз.",
    "signed_out": "Этот вход уже завершён, и это нажатие ничего не удалило. Если вы уже удаляли данные — здесь, в боте или на другом устройстве, — они удалены; если нет, войдите и удалите их снова.",
    "unknown": "Не знаем, удалились ли данные: ответ на прошлое нажатие потерялся, а входа уже нет."
  },
  "identity": {
    "error": {
      "title": "Не удалось проверить вход",
      "body": "Приложение открыто, но записи не уйдут, пока сервер не ответит."
    },
    "offline": {
      "title": "Работаем без связи",
      "body": "Покупки сохраняются на телефоне и уйдут, когда появится интернет."
    }
  },
  "login": {
    "title": "Вход",
    "promise": "Что брать на новом месте — и где",
    "offer": {
      "title": "Войдите через Telegram",
      "body": "Так покупки и оценки не потеряются при смене телефона. Ни имени, ни номера телефона мы не храним."
    },
    "start": "Войти через Telegram",
    "starting": "Открываем Telegram…",
    "waiting": {
      "title": "Откройте Telegram и нажмите «Войти»",
      "body": "Ссылка живёт пять минут. Возвращайтесь сюда — приложение узнает вас само."
    },
    "open": "Открыть Telegram",
    "restart": "Начать заново",
    "welcome": {
      "title": "Вход выполнен. Это ваш аккаунт?",
      "body": "Дальше всё, что вы запишете, попадёт именно сюда.",
      "created": "Аккаунт создан: {day}"
    },
    "confirm": "Да, это я",
    "refuse": "Это не я",
    "unavailable": {
      "title": "Ссылка больше не действует",
      "body": "Так бывает, если прошло пять минут или вход уже забрали. Начните заново."
    },
    "rate_limited": {
      "title": "Слишком много попыток входа",
      "body": "Столько запросов сейчас у всех вместе. Попробуйте через минуту."
    },
    "disabled": {
      "title": "Вход через Telegram не настроен",
      "body": "В этой копии нет бота. Так бывает только в разработке."
    },
    "error": {
      "title": "Не удалось войти",
      "body": "Что-то помешало входу. Попробуйте ещё раз."
    },
    "offline": {
      "title": "Без интернета не войти",
      "body": "Попробуем сами, как только связь вернётся."
    },
    "erased": "Ваши данные удалены. Войти снова можно — это будет новый пустой аккаунт.",
    "erase_unknown": "Не знаем, удалились ли ваши данные: ответ сервера потерялся. Войдите — если аккаунт пустой, они удалены; если нет, удалите их снова.",
    "erase_kept": "Вход на этом устройстве уже был завершён, и это нажатие ничего не удалило. Войдите: если аккаунт пустой, данные уже удалены; если нет — удалите их снова."
  },
  "dev": {
    "kit": {
      "title": "Кит",
      "buttons": "Кнопки",
      "fields": "Поля",
      "badges": "Бейджи",
      "icons": "Иконки",
      "selection": "Выбранное и неактивное",
      "busy": "Идёт работа",
      "segment_fit": "Единица · по ширине слов",
      "segment_inactive": "Единица · нельзя сейчас",
      "switch_off": "Выключен",
      "switch_on": "Включён",
      "switch_inactive_off": "Нельзя сейчас · выключен",
      "switch_inactive_on": "Нельзя сейчас · включён",
      "checkbox_off": "Флажок снят",
      "checkbox_on": "Флажок отмечен",
      "checkbox_inactive_off": "Флажок снят, нельзя сейчас",
      "checkbox_inactive_on": "Флажок отмечен, нельзя сейчас",
      "cards": "Карточки",
      "open_sheet": "Открыть шторку",
      "open_long_sheet": "Открыть длинную шторку",
      "long_sheet": "Длинная шторка",
      "open_states_sheet": "Открыть шторку состояний",
      "states_sheet": "Состояния в шторке",
      "open_wide_sheet": "Открыть шторку длинных имён",
      "wide_title": "Электрооборудованиепромышленноговнедрения",
      "wide_meta": "Счёт «Накопительныйсчётнаотпускиподаркиродными»",
      "wide_line": "ГАЗ.НАПИТОК КОКА-КОЛА ZERO 0,33Л Ж/Б ПРОМО 2+1 СКИДКА 24.10.2026",
      "long_row": "Строка {n}",
      "sample_milk": "Молоко «Ашхар»",
      "sample_meta": "ультрапастеризованное, 2,5%",
      "date": "Дата",
      "scanned": "Прочитано: {code}",
      "rows": "Строки и подписи",
      "operations": "Строка операции",
      "pace_day": "К {day} сентября",
      "skeleton": "Скелетон",
      "states": "Состояния",
      "state_screen": "Ошибка экрана",
      "state_section": "Секцией",
      "state_flow": "Под словами",
      "caption_month": "Сентябрь 2026",
      "row_cash": "Наличные драмы",
      "row_details_long": "Вчера · Подарок коллеге на день рождения, цветы и торт · Торговый центр «Ташир»",
      "row_short": "Наличные",
      "row_short_meta": "Карта",
      "row_card": "Карта Ардшин",
      "row_long": "Сыр Лори, рассольный, из Ширака, на развес у прилавка рынка",
      "row_long_meta": "Заголовок переносится, а meta держит не больше двух строк: всё, что длиннее, кончается многоточием, чтобы строка не росла без конца",
      "row_whole": "Объяснение — meta целиком",
      "row_whole_meta": "Шаг объясняет, и обрезанный многоточием он ничего не объясняет: с whole подпись стоит целиком, во сколько строк ни встанет, — как шаги новичка на «Что брать» на телефоне шириной 320",
      "row_warn": "Чек от 27 сент., 18:10",
      "row_warn_meta": "не удалось прочитать — tone=\"warn\"",
      "row_good": "Ереван Сити",
      "row_good_meta": "чек уже записан — tone=\"good\"",
      "row_download_meta": "Действует сразу — без шеврона",
      "row_erase_meta": "Спросит подтверждение — без шеврона",
      "row_link": "Ссылка с продолжением",
      "row_link_meta": "Открывает экран — с шевроном",
      "row_device": "iPhone · Safari",
      "row_device_meta": "Не нажимается: в хвосте своя кнопка",
      "note_plain": "Валюта дохода и валюта трат совпадают — курс считать не нужно.",
      "note_warn": "Города нет в списке — цены будут видны только вам.",
      "strip": "Связь одной строкой",
      "strip_offline": "Без связи · графики на 14:05",
      "strip_offline_long": "Без связи · настройки на 14:05. Изменения можно сохранить, когда интернет появится",
      "strip_unanswered": "Список на вчера в 21:40 — сервер не ответил",
      "strip_refreshing": "Обновляем · список на вчера в 21:40",
      "caption_goes_on": "Открывает продолжение",
      "caption_acts": "Действует сразу или спрашивает",
      "row_link_inactive": "Ссылка, пока нет связи",
      "row_link_offline": "Откроется, когда появится связь",
      "search": "Поле поиска",
      "search_clear": "«Что брать» · «Очистить»",
      "search_scan": "«Что взяли?» · сканер",
      "search_readonly": "Только чтение",
      "search_sample": "сыр",
      "search_scanner": "Сканер в поле"
    },
    "login_seam": "Войти для разработки",
    "login_insecure": "По http вход не работает: нужен make certs"
  },
  "error": {
    "invalid_amount": "Это не похоже на сумму",
    "invalid_quantity": "Это не похоже на количество",
    "invalid_rate": "Это не похоже на курс",
    "invalid_score": "Оценка бывает от 1 до 5",
    "currency_mismatch": "Разные валюты нельзя складывать",
    "unit_mismatch": "Разные единицы нельзя сравнивать",
    "not_found": "Не нашли",
    "conflict": "Это уже занято",
    "no_actor": "Это устройство больше не узнаём",
    "trip_open": "Уже открыта другая запись",
    "internal": "Что-то пошло не так",
    "trip_context_required": "Для отправки записи укажите её город и валюты",
    "login_unavailable": "Этот запрос входа больше недоступен. Начните заново",
    "login_forbidden": "Откройте вход из приложения",
    "login_rate_limited": "Слишком много запросов входа. Попробуйте через минуту",
    "login_disabled": "Вход через Telegram пока не настроен",
    "bot_unauthorized": "Бот не прошёл проверку доступа",
    "exchange_in_future": "Этот день ещё не наступил",
    "income_in_future": "Этот день ещё не наступил",
    "spending_in_future": "Этот день ещё не наступил",
    "spending_category_unknown": "Такой категории нет — выберите другую",
    "spending_category_taken": "Категория с таким названием уже есть",
    "money_account_in_future": "Этот день ещё не наступил",
    "money_account_taken": "Счёт с таким названием уже есть — назовите иначе",
    "money_account_currency": "Этот счёт в другой валюте",
    "money_account_currency_locked": "По счёту уже есть операции — валюту не сменить. Нужна другая — заведите новый счёт",
    "transfer_in_future": "Этот день ещё не наступил",
    "transfer_account": "Этого счёта больше нет или он в другой валюте — выберите другой",
    "spending_of_transfer": "Это комиссия перевода — она меняется вместе с ним, в листе перевода",
    "barcode_shape": "В штрихкоде 8, 12 или 13 цифр",
    "barcode_check_digit": "Цифры не сходятся — проверьте код",
    "barcodes_full": "У этого товара уже двадцать кодов — больше не записать",
    "barcode_in_store": "Это этикетка магазина — такой код не записывается в справочник",
    "receipt_not_photo": "Это не фото чека. Снимите чек ещё раз",
    "receipt_too_large": "Фото слишком большое. Снимите чек ещё раз",
    "receipt_not_ready": "Чек ещё не разобран — записать его пока нельзя",
    "receipt_recorded_before": "Этот чек уже записан",
    "receipt_in_future": "Дата чека ещё не наступила",
    "receipt_total_required": "Укажите итог чека — без него записывать нечего",
    "receipt_link_invalid": "Это не ссылка с чека налоговой Сербии, или она повреждена",
    "feedback_rate_limited": "Сегодня сообщений уже много. Текст сохранён — отправьте завтра",
    "feedback_picture_invalid": "Снимок не подошёл — выберите другой",
    "feedback_picture_too_large": "Снимок слишком большой — выберите другой",
    "client_errors_rate_limited": "Слишком много отчётов о сбоях. Попробуйте через минуту"
  },
  "settings": {
    "title": "Настройки",
    "country": "Страна",
    "countries": {
      "AM": "Армения",
      "GE": "Грузия",
      "RS": "Сербия"
    },
    "city": "Город",
    "spendCurrency": "Валюта трат",
    "incomeCurrency": "Валюта для пересчёта",
    "currencies": {
      "AMD": "Армянский драм · AMD",
      "RUB": "Российский рубль · RUB",
      "USD": "Доллар США · USD",
      "EUR": "Евро · EUR",
      "GEL": "Грузинский лари · GEL",
      "RSD": "Сербский динар · RSD"
    },
    "conversion_hint": "В этой валюте показываем, сколько стоят покупки. Это не запись о доходе.",
    "scope": "Новые настройки — для следующих записей. Уже начатые сохранят свою валюту и курс",
    "saved": "Настройки сохранены",
    "save": "Сохранить",
    "saving": "Сохраняем…",
    "overwrite": "Применить мои изменения",
    "cancel": "Отменить изменения",
    "offline": {
      "strip": "Без связи · настройки на {when}. Изменения можно сохранить, когда интернет появится",
      "title": "Нет связи",
      "body": "Настройки появятся, когда интернет восстановится",
      "strip_untimed": "Без связи · настройки из памяти телефона. Изменения можно сохранить, когда интернет появится"
    },
    "context_missing": "На этом устройстве ещё нет подтверждённых настроек. Подключитесь к сети, чтобы загрузить их.",
    "conflict": {
      "title": "Настройки изменились на другом устройстве",
      "body": "Сейчас сохранено: {country}, {city}; покупки — {spendCurrency}, пересчёт — {incomeCurrency}. Ваши правки ниже. Примените их или отмените, чтобы взять сохранённые."
    },
    "legacy": {
      "title": "Уточните город и валюты записи",
      "body": "Эта запись начата в прежней версии приложения. Проверьте, где и в какой валюте вы покупали. Все позиции ждут на телефоне.",
      "action": "Уточнить настройки записи",
      "confirm": "Подтвердить и отправить"
    },
    "group_place": "Где живёте",
    "group_currencies": "Валюты",
    "city_hint": "Используем город для новых записей и цен рядом с вами",
    "city_current": "Сейчас: {city}",
    "city_not_listed": "Этого города нет в списке — можно оставить его или выбрать доступный",
    "city_changed": "В «Что брать» появятся цены для нового города. Ваши прежние покупки останутся",
    "same_currencies": "Валюты совпадают — пересчёт не нужен",
    "changed": "изменено",
    "changed_announced": "изменено, не сохранено",
    "save_needs_network": "Сохранить можно, когда появится связь",
    "save_unchanged": "Сохранить · изменений нет",
    "stale_error": "Сервер не ответил · настройки на {when}",
    "stale_error_untimed": "Сервер не ответил · настройки из памяти телефона",
    "stale_loading": "Обновляем · настройки на {when}",
    "stale_loading_untimed": "Обновляем · настройки из памяти телефона",
    "draft": {
      "title": "Есть несохранённые изменения",
      "volatile": "Изменения останутся только пока приложение открыто"
    },
    "load_error": {
      "title": "Не удалось загрузить настройки",
      "body": "Попробуйте ещё раз"
    },
    "save_error": {
      "title": "Не удалось сохранить изменения",
      "body": "Введённое осталось. Попробуйте ещё раз"
    },
    "save_unknown": {
      "title": "Связь прервалась во время сохранения",
      "body": "Сверим с сервером, когда она вернётся. Введённое не пропадёт"
    },
    "spend_hint": "По умолчанию для новых записей. У покупки можно выбрать другую валюту",
    "group_account": "Аккаунт",
    "sign_out": "Выйти",
    "group_data": "Ваши данные",
    "analytics": {
      "label": "Учитывать меня в статистике",
      "hint": "Отметки, что вы открывали «Что брать», подсчёт оценок и замер поиска по вашим запросам — так мы понимаем, нужна ли Molvia и находит ли поиск нужное. Выключите — прошлые отметки удалятся."
    },
    "export": {
      "label": "Скачать мои данные",
      "hint": "Ваши записи, оценки и настройки — одним файлом",
      "offline": "Скачать можно, когда появится связь",
      "busy": "Готовим файл…",
      "failed": "Не получилось подготовить файл",
      "lost": "Связь пропала — попробуйте, когда она вернётся",
      "ready": "Файл готов",
      "hand_over": "Сохранить или отправить"
    },
    "group_money": "Деньги",
    "group_bot": "Бот",
    "group_scheme": "Тема",
    "scheme": {
      "system": "Системная",
      "light": "Светлая",
      "dark": "Тёмная",
      "hint": "Выбор действует только на этом устройстве"
    },
    "tap": {
      "offline": "Без связи не сохранить — переключатель заработает, когда связь вернётся.",
      "save_failed": "Не сохранилось. Проверьте связь и попробуйте ещё раз.",
      "unsure": "Ответ не пришёл — не знаем, сохранилось ли. Проверяем ещё раз.",
      "waiting": "Сохраняем — ответа ещё нет. Покажем, когда придёт.",
      "load_error": "Не удалось загрузить настройку."
    },
    "salary_shift": {
      "label": "Зарплата — в следующий месяц",
      "day": "С какого числа",
      "day_option": "с {day}-го",
      "hint": "Зарплата, пришедшая с этого числа, считается в «Пришло» следующего месяца. День поступления и остатки на счетах это не меняет."
    },
    "bot": {
      "hint": "Напоминания и чеки"
    },
    "erase": {
      "label": "Удалить мои данные",
      "hint": "Всё и навсегда"
    },
    "group_app": "О приложении",
    "feedback": {
      "label": "Написать разработчику",
      "hint": "Ошибка, идея или вопрос. Ответ придёт в Telegram"
    }
  },
  "feedback": {
    "title": "Написать разработчику",
    "title_error": "Сообщить о проблеме",
    "kind_label": "О чём",
    "kinds": {
      "bug": "Сломалось",
      "idea": "Идея",
      "other": "Другое"
    },
    "text_label": "Сообщение",
    "placeholder": {
      "bug": "Что делали и что пошло не так",
      "idea": "Чего не хватает",
      "any": "Пишите как есть"
    },
    "attached": "Вместе с текстом:",
    "attached_build": "версия {build}",
    "attached_screen": "экран «{screen}»",
    "attached_code": "код {code}",
    "attached_pictures": "{n} снимок | {n} снимка | {n} снимков",
    "picture": {
      "list": "Снимки к сообщению",
      "alt": "Снимок {n}",
      "remove": "Убрать снимок {n}",
      "add": "Приложить снимок",
      "adding": "Готовим снимок…",
      "hint": "Снимите экран кнопками телефона и приложите из галереи. Уйдёт только то, что вы приложите.",
      "unreadable": "Не получилось открыть картинку — выберите другую",
      "shape": "Картинка слишком узкая или длинная — выберите другую",
      "lost": "Снимки не сохранились — приложите снова",
      "too_many": "Поместилось {n} из {total} — к сообщению идёт не больше трёх снимков. Уберите один, чтобы приложить другой"
    },
    "languages": {
      "ru": "русский язык",
      "en": "английский язык"
    },
    "platform": {
      "app": "{os}, приложение",
      "browser": "{os}, браузер"
    },
    "systems": {
      "ios": "iOS",
      "ipados": "iPadOS",
      "android": "Android",
      "macos": "macOS",
      "windows": "Windows",
      "linux": "Linux",
      "other": "другая система"
    },
    "send": "Отправить",
    "sending": "Отправляем…",
    "done": "Готово",
    "need_kind": "Выберите, о чём сообщение",
    "need_text": "Напишите сообщение или приложите снимок",
    "need_network": "Отправить можно со связью",
    "need_tomorrow": "Отправить можно завтра",
    "offline": "Нет связи. Текст сохранён — отправите, когда она появится",
    "unsupported": "В сообщении есть знак, который нельзя отправить",
    "sent": {
      "title": "Спасибо, прочитаем",
      "body": "Если ответим, ответ придёт в Telegram, в бот Molvia"
    },
    "limit": {
      "title": "Сегодня сообщений уже много",
      "body": "Текст сохранён — отправьте завтра"
    },
    "failed": {
      "title": "Не получилось отправить",
      "body": "Текст остался — попробуйте ещё раз"
    }
  },
  "field": {
    "clear": "Очистить",
    "left": "Осталось {n} знак | Осталось {n} знака | Осталось {n} знаков",
    "full": "Больше не поместится: {max} знаков"
  },
  "privacy": {
    "title": "Данные и приватность",
    "summary": "Список ваших покупок никому не показывается. Цены другие видят без имени и только в магазине, где товар купили хотя бы трое, оценки — только средней от трёх человек. Товары, магазины и штрихкоды, которые вы добавили, и ваше слово о строке чека видят все — тоже без имени, но и без порога. Рекламы нет, сторонних трекеров и аналитики — тоже.",
    "operator": {
      "title": "Кто отвечает за данные",
      "text": "Molvia делает и за ваши данные отвечает Владимир Ситчихин — частное лицо, Гюмри, Армения. Связаться с ним — «Написать разработчику» в настройках: сообщение приходит ему лично."
    },
    "stored": {
      "title": "Что мы храним",
      "telegram": {
        "term": "Номер аккаунта Telegram",
        "text": "Чтобы узнать вас на любом устройстве. Имя, username и фото не храним."
      },
      "purchases": {
        "term": "Покупки",
        "text": "Что, где, когда и почём. Это самое личное: по ним видно, где вы бываете. Список покупок видите только вы. Цену, которую вы заплатили, другие могут увидеть без имени и только в магазине, где этот товар купили хотя бы трое, — и тогда цена магазина может оказаться вашей."
      },
      "exchanges": {
        "term": "Обмены денег",
        "text": "Сколько, какой валюты и когда вы меняли, и заметка «где», если вы её пишете, — из них считается ваш курс. Когда вы исправляете обмен, прежняя версия хранится рядом, пока жив сам обмен. Видите только вы."
      },
      "incomes": {
        "term": "Доходы",
        "text": "Сколько, в какой валюте, когда и откуда пришло, и заметка, если вы её пишете, — по ним тоже считается ваш курс. Когда вы исправляете доход, прежняя версия хранится рядом, пока жив сам доход. Видите только вы."
      },
      "spendings": {
        "term": "Траты вне покупок в магазине",
        "text": "Сколько, в чём, когда, в какой категории, и «что это» и «где», если вы их пишете, — и свои категории. Трата в другой валюте хранит курс своего дня, а прошедший месяц — курс своего последнего дня, посчитанный по вашим обменам. Видите только вы."
      },
      "receipts": {
        "term": "Чеки",
        "text": "Фото чека, которое вы отправили, и что с него прочитано: номер налогоплательщика магазина, дата, строки и итог. Читает его наш сервер; если вам включено чтение чеков моделью Claude, фото целиком уходит ей — в компанию Anthropic (см. «Кому уходят данные»). Других сторонних сервисов фото не видит. Сербский чек приходит ссылкой из его QR-кода, без фото: QR читает телефон, снимок с него не уходит, — о нём раздел «Сербский чек по ссылке». У нас фото удаляется, как только вы запишете чек, а незаписанный чек — целиком через 28 дней после отправки. Кроме чека, который модель прочитала не целиком: его фото и то, что прочитала модель, разработчик хранит до 21 дня после чтения — и после записи, и после «Переснять» тоже, — чтобы найти, почему строки не прочитались, и исправить чтение; потом удаляет. Разработчику в Telegram приходит сообщение о таком чеке: начало его номера, страна, сколько строк не прочитано и почему — без товаров, сумм и магазина. Ни в ночную копию, ни в журналы это не попадает; в копии ваших данных видно, что хранится, до когда и почему. Удалите чек или свои данные — уйдёт и это. Фото, отправленное Anthropic, живёт у неё до 30 дней, а отмеченное её проверкой — до 2 лет (см. «Кому уходят данные»). Строки товаров, вырезанные из фото (без шапки, где бывает ваше имя, и без итога), хранятся не дольше 28 дней после записи — на них учится распознавание; у чека, прочитанного моделью, строки не вырезаются. Если вы ушли с экрана, пока чек разбирался, бот Molvia напишет в Telegram, что он готов: в сообщении — магазин или дата чека и число позиций, без сумм и товаров; это сообщение Telegram видит. Здесь хранится, как вы узнали, что чек готов, — в приложении или от бота, — и выключено ли это сообщение. Записанный чек хранится, пока в «Покупках» есть его запись: удалите запись — через 10 минут уйдёт и чек со всеми строками. Удалите одну покупку — сразу уйдёт её строка. С записью или покупкой уходит и ваше слово о строке в памяти магазина; если ту же строку записала другая ваша покупка в том же магазине, слово снова берётся из неё — её товар, цена и день. Строки, которые вы не стали записывать, удаляются при записи."
      },
      "accounts": {
        "term": "Счета",
        "text": "Имя счёта, его валюта, отметка «сбережения», остаток на день старта и ваши сверки с фактом — сколько вы насчитали и сколько посчитало приложение; у трат, доходов, обменов и покупок — с какого счёта и сколько списано. Остаток не хранится, а считается. Видите только вы."
      },
      "places": {
        "term": "Магазины",
        "text": "Названия магазинов, которые вы указываете в покупках, — в общем справочнике, без вашего имени."
      },
      "barcodes": {
        "term": "Штрихкоды",
        "text": "Код, который вы привязали к товару, и когда. Сам код — в общем справочнике: по нему товар находят все, но чей он, никому не показывается."
      },
      "ratings": {
        "term": "Оценки и отзывы",
        "text": "Отзыв видите только вы. Оценку другие видят только в средней от трёх человек. Снятая оценка остаётся у нас строкой без отзыва — почему, сказано в разделе «Статистика — с вашего согласия». Если две карточки товара оказались одной и их склеили, а оценка по старой карточке легла поверх вашей оценки другой, прежняя — балл и даты, без отзыва — хранится, пока склейку можно отменить: отменой её вернём."
      },
      "reminders": {
        "term": "Напоминания об оценке",
        "text": "Когда бот последний раз напоминал вам оценить покупки и какое это было напоминание по счёту — чтобы писать реже, если вы не отвечаете. И выключены ли напоминания — вами или потому, что вы заблокировали бота, — и с какого момента бот заблокирован. В самом сообщении в Telegram уходят название товара и магазин: иначе не понять, о чём вопрос."
      },
      "feedback": {
        "term": "Сообщения разработчику",
        "text": "Что вы написали в «Написать разработчику» или ответом на его ответ в боте Molvia, какого это вида, и что приложено к тексту: версия приложения, экран, система телефона и приложение это или браузер, язык, а с экрана ошибки — её код. Снимки экрана, если вы приложили их сами: из файла до отправки убирается всё, кроме картинки, — и место съёмки тоже. Снимок хранится, только пока не дойдёт до разработчика в Telegram, и не дольше недели; Telegram его видит, как и текст, и копия остаётся в чате разработчика. И ответы разработчика, а у каждого — номер сообщения, которым он пришёл вам в Telegram: по нему ваш ответ попадает в ту же переписку. Читает только разработчик. Копия сообщения приходит ему в Telegram без вашего имени и номера аккаунта и остаётся в его чате, даже когда здесь сообщение удалено. Хранится год от последнего сообщения переписки."
      },
      "search": {
        "term": "Выбор в поиске",
        "text": "Что вы взяли по какому запросу — чтобы в следующий раз нужное было первым. И запрос, который ничего не нашёл, если товар вы потом нашли другим словом, — чтобы в следующий раз ваше слово находило его. Другим людям ваши пары не видны. С вашего согласия по ним разработчик меряет поиск, а запрос, который ничего не нашёл, может войти в общий словарь поиска — без имени и только от трёх человек; об этом раздел «Статистика — с вашего согласия»."
      },
      "visits": {
        "term": "Отметки о визитах",
        "text": "Открывали ли вы «Что брать» — не чаще раза в день. Только для статистики и только с вашего согласия — о нём раздел «Статистика — с вашего согласия»."
      },
      "devices": {
        "term": "Устройства входа",
        "text": "Название телефона и браузера, с которых вы вошли, и когда вы ими пользовались. Список — в настройках, в «Устройствах»: там любой вход можно завершить. Вход, которым не пользовались полгода, удаляется сам."
      },
      "settings": {
        "term": "Ваши настройки",
        "text": "Страна, город, валюты и день, когда вы сменили валюту пересчёта, — и для «Учитывать меня в статистике»: с какого момента оно выключено и когда вы последний раз включали его обратно. И когда вы последний раз пользовались приложением или входили в него: по этому дню считаются два года из «Неактивного аккаунта». И когда бот последний раз предупредил, что аккаунт скоро удалится, — за 30 или за 7 дней: чтобы не предупреждать дважды."
      },
      "consent": {
        "term": "Согласие с условиями",
        "text": "Какую редакцию «Условий использования» и этой страницы вы приняли и когда — чтобы при существенных изменениях спросить вас снова. Возраст и дату рождения мы не храним."
      }
    },
    "bases": {
      "title": "Зачем и на каком основании",
      "text": "Почти всё из списка выше нужно, чтобы Molvia работала: вы приняли «Условия использования», и это наш договор. Отказаться от этих данных, оставшись в Molvia, нельзя — можно только удалить аккаунт.\nОдно — с вашего отдельного согласия: статистика, о ней следующий раздел.\nЧто мы делаем с данными: получаем от вас, храним, показываем вам, считаем из них средние оценки и цены для других — без имени, передаём тем, кто назван в разделе «Кому уходят данные», и удаляем."
    },
    "statistics": {
      "title": "Статистика — с вашего согласия",
      "text": "Чтобы понять, нужна ли Molvia людям, разработчик считает две вещи: возвращаются ли люди — по отметкам о визитах — и сколько оценок ставят, считая снятые. Считает он числами, без имён и без того, что вы оценили.\nЕщё он меряет поиск: ставит ли тот первым то, что люди потом берут, — по тому, что вы взяли по какому запросу. Для этого разработчик выгружает такие пары себе — без имени и номера аккаунта, с запросом так, как его хранит поиск (без регистра и в одном написании: «молоко» — moloko), — и удаляет выгрузку после замера. В итог идут числа и одно слово: запрос, который ничего не нашёл, а товар вы потом нашли другим словом, может войти в общий словарь поиска — без имени и только если так же сказали хотя бы трое.\nСогласие действует, пока в настройках включено «Учитывать меня в статистике», — а включено оно, пока вы его не выключили. Выключить можно в любой момент: отметки о визитах удалятся сразу и больше писаться не будут, а ваши оценки и запросы перестанут считаться в этом счёте. Включить обратно — там же: оценки и запросы снова в счёте, и те, что сделаны, пока было выключено.\nОтдельно от этого, без чьего-либо имени и номера — только числами по дням, — считается, сколько входов началось и закончилось, сколько чеков прочитано, как скоро после отправки их записали и сколько строк в них поправлено или оставлено незаписанными, сколько напоминаний ушло, сколько оценок дано в ответ на них и сколько раз напоминания выключали — кнопкой, в настройках или заблокировав бота: так видно, работают ли вход, чтение чеков и напоминания. В этих числах нет никого, поэтому выключатель их не касается.\nСнятая оценка остаётся у нас строкой — без отзыва, но с самой оценкой и моментом, когда вы её поставили: по ней бот не спрашивает об оценке покупки, которую вы сняли. Она остаётся и после выключения статистики, но в счёт уже не идёт, и уходит вместе с аккаунтом."
    },
    "recipients": {
      "title": "Кому уходят данные",
      "people": {
        "term": "Другим людям",
        "text": "Средние оценки от трёх человек и цены без имени — тем, у кого открыт доступ к чужим цифрам. Без доступа и без порога трёх все видят товары, магазины и штрихкоды, которые вы добавили в общий справочник, и ваше слово о чеке — какой товар стоит за строкой и какой это магазин: его подставят любому, кто разберёт чек того же магазина, даже если так сказали только вы. И с вашего согласия на статистику — запрос, который ничего не нашёл, в общем словаре поиска, если так же сказали хотя бы трое. Всё это без вашего имени. Ваш список покупок, траты и деньги — никому."
      },
      "telegram": {
        "term": "Telegram",
        "text": "Сообщения бота вам — вход, напоминания, «чек разобран», ответы разработчика, сообщение об утечке данных, предупреждение перед удалением неактивного аккаунта — и ваши сообщения разработчику со снимками. Telegram — зарубежная компания; передать ему это нужно, потому что вход и бот Molvia работают через Telegram, — этот канал вы выбрали сами, когда вошли."
      },
      "contabo": {
        "term": "Contabo, сервер во Франции",
        "text": "Хостинг: на его сервере лежит база."
      },
      "cloudflare": {
        "term": "Cloudflare",
        "text": "Хранит в ЕС зашифрованные копии базы; ключа к ним у него нет."
      },
      "open_food_facts": {
        "term": "Open Food Facts",
        "text": "Только незнакомый штрихкод — без вас."
      },
      "serbian_tax": {
        "term": "Налоговая Сербии",
        "text": "Ссылка сербского чека: сумма, время, номер чека и номер покупателя, если он в чеке указан, — фирмы или ваш. Не ваш телефон и не ваш вход."
      },
      "anthropic": {
        "term": "Anthropic: США и другие страны",
        "text": "Фото чека целиком — только если вам включено чтение чеков моделью Claude; на фото бывает ваше имя, если магазин его печатает. Хранит присланное Anthropic в США, а считает — в любой стране, где у неё есть мощности; в какой именно, заранее не знаем и мы. Модель возвращает строки, итог и магазин, и хранятся они у нас, как любой разобранный чек. У Anthropic фото и ответ модели живут до 30 дней, а если её автоматическая проверка отметит запрос как нарушение её правил, — до 2 лет, и оценка этой проверки — до 7 лет. Это передача за рубеж, и держится она на вашем согласии с этой редакцией: без него чек читает только наш сервер. По условиям Anthropic для API присланное не идёт на обучение её моделей."
      },
      "nobody": {
        "term": "Больше никому",
        "text": "Данные мы не продаём и рекламе не отдаём."
      }
    },
    "logs": {
      "title": "Логи сервера",
      "text": "Хранятся не дольше 14 дней. Запросы в них пишутся без IP-адреса и без того, что вы искали. IP-адрес может попасть в журнал ошибок сервера — и живёт там тоже не дольше 14 дней — и в память сервера вместе со сбоем приложения: об этом раздел «Сбои приложения». И ещё сервер хранит метрики: сколько запросов пришло к каждому разделу и как быстро он ответил, — по 15 секунд, без имени, адреса и того, что вы искали: так видно, не сломалось ли что-то. Видны из них последние 30 дней, а с диска они уходят помесячно — до двух месяцев."
    },
    "failures": {
      "title": "Сбои приложения",
      "text": "Если в приложении что-то ломается, телефон отправляет разработчику вид ошибки, экран, где она случилась, версию приложения и систему телефона — без ваших данных: без текста, который вы ввели, без покупок и без вашего аккаунта. Адрес телефона в базу не записывается: сервер держит его в памяти час после последнего сбоя, присланного с этого адреса, — чтобы с одного адреса не приходило слишком много. Пока нет связи, это ждёт на телефоне. Хранится 30 дней."
    },
    "backups": {
      "title": "Где лежат данные и копии",
      "text": "Сервер — во Франции, у хостинга Contabo. Раз в сутки база копируется в зашифрованном виде в хранилище Cloudflare в ЕС; расшифровать копию может только владелец Molvia. Копии живут 14 дней — через 14 дней после удаления ваших данных нет и в них. Если сервер когда-нибудь придётся восстанавливать из копии, удаление, сделанное меньше чем за сутки до сбоя, может понадобиться повторить. Фото чеков, вырезанные из них строки и снимки к сообщениям разработчику в копии не попадают. Хранить данные во Франции армянский закон разрешает без отдельного разрешения: Франция — в его списке стран с достаточной защитой, а без сервера нет и сервиса."
    },
    "barcodes": {
      "title": "Незнакомый штрихкод",
      "text": "Если справочник не знает отсканированный код, сервер спрашивает о нём Open Food Facts — открытую базу продуктов. Туда уходят только сам код и адрес нашего сервера: не вы, не ваш телефон и не ваш вход. Код этикетки магазина туда не уходит. Название и объём оттуда — только подсказка, вы их подтверждаете или правите; товары, предложенные с кодом, который Open Food Facts знает, помечаются. Ссылка «По данным Open Food Facts» открывает страницу товара там — уже с вашего телефона, когда вы на неё нажмёте. Данные Open Food Facts открыты по лицензии ODbL: выгрузку того, что справочник взял оттуда, пришлём по запросу."
    },
    "serbian_receipts": {
      "title": "Сербский чек по ссылке",
      "text": "Сербский чек вы передаёте ссылкой из его QR-кода, без фото: QR со снимка читает ваш телефон, а сам снимок остаётся на нём и нигде не хранится — или вы вставляете ссылку сами. Чек хранит налоговая Сербии (Пореска управа), и строки наш сервер берёт у неё: отправляет ей эту ссылку, а затем открывает по ней страницу чека и просит список товаров — с номером чека и ключом с этой же страницы, ради кодов товаров. Налоговая видит ссылку и адрес нашего сервера — не вас, не ваш телефон и не ваш вход. В ссылке — сумма, время и номер чека, а если в чеке указан покупатель, то и его номер — фирмы или ваш; всё это у налоговой уже есть. Из ответа мы храним номер налогоплательщика продавца, код и название магазина, город, строки — с кодами товаров, где магазин их передал, — итог и время чека; имя кассира, номер покупателя и способ оплаты не берём. Код товара из чека становится штрихкодом в общем справочнике, только если вы нажмёте «Привязать и записать». Ещё храним, прочитал ли QR телефон или ссылку вставили и промахнулась ли до этого камера, — так мы видим, хорошо ли читается QR. Саму ссылку стираем, как только налоговая ответила, и никогда не пишем в журналы. Только что пробитый чек налоговая показывает через пару минут: сервер спрашивает снова, двое суток, а потом говорит, что чека не нашли."
    },
    "storage": {
      "title": "Cookie и память телефона",
      "text": "Cookie две: вход и ещё одна на пять минут, пока вы входите. Телефон хранит последнее, что вы видели, и то, что ещё не ушло на сервер. Всё это нужно, чтобы приложение работало, поэтому баннера нет. «Выйти» в настройках стирает всё это с телефона."
    },
    "copy": {
      "title": "Копия ваших данных",
      "text": "В настройках — «Скачать мои данные»: файл со всем, что лежит о вас в базе, вместе с прежними версиями исправленных обменов и доходов, товарами, которые вы добавили в общий справочник, штрихкодами, которые вы привязали, прочитанными чеками — без фото — сообщениями разработчику — без снимков — и прежними оценками, которые хранятся до отмены склейки. Снятая оценка там тоже: без отзыва она остаётся у нас — почему, сказано в разделе «Статистика — с вашего согласия». Удалённое, что ещё можно вернуть, — тоже, с отметкой. Ключей входа в файле нет."
    },
    "erase": {
      "title": "Удалить всё",
      "text": "В настройках — «Удалить мои данные», или отправьте /delete боту, через которого входите, и подтвердите. Из базы данные удаляются сразу и насовсем, из резервных копий — в течение 14 дней: уходит всё из списка выше, кроме магазинов, — они, товары, которые вы добавили в общий справочник, привязанные вами штрихкоды и память магазинов — какой товар стоит за строкой чека и цена с полки — остаются без вашего имени. До фото чеков, которые читала модель Claude, удаление не достаёт: у Anthropic они и ответы модели живут свой срок — до 30 дней, отмеченные её проверкой — до 2 лет, оценка проверки — до 7 лет (см. «Кому уходят данные»). Удаление из настроек стирает и копии на телефоне, с которого вы удаляли; на других устройствах — и после /delete — они могут остаться: чтобы убрать их, удалите там приложение или очистите данные сайта — или заранее выйдите там в настройках. Войти снова можно, но это будет новый пустой аккаунт. После удаления остаётся одно число без имени: сколько человек, пришедших в ту же неделю, что и вы, удалили свои данные, и у скольких из них аккаунт удалился сам, за два года без визитов. Оно нужно, чтобы честно считать, пользуются ли Molvia."
    },
    "inactive": {
      "title": "Неактивный аккаунт",
      "text": "Если два года вы не открываете Molvia, аккаунт удалится сам — так же, как по «Удалить мои данные». За 30 и за 7 дней бот Molvia предупредит; чтобы оставить аккаунт, достаточно открыть приложение и войти, если оно попросит. Если бот у вас заблокирован, предупредить нечем, и аккаунт удалится без предупреждения."
    },
    "rights": {
      "title": "Ваши права",
      "text": "Узнать, что о вас хранится, и получить копию — «Скачать мои данные». Исправить — правкой: у покупки — количество и сумма, у записи — сумма чека, и ещё оценки, отзывы, обмены, доходы, траты, счета и настройки. Товар покупки и магазин или день записи не правятся — такую запись удалите и внесите заново. Удалить всё — «Удалить мои данные» или /delete в боте. Отозвать согласие на статистику — «Учитывать меня в статистике». Всё это работает сразу, без запроса. Если нужно что-то другое — напишите разработчику: ответ придёт не позже чем через пять рабочих дней."
    },
    "complaints": {
      "title": "Куда пожаловаться",
      "text": "Если вы считаете, что мы нарушили ваши права на данные, можно пожаловаться в орган по защите данных своей страны: в Армении — Агентство по защите персональных данных при Министерстве юстиции (pdpa.am), в Грузии — Государственная аудиторская служба (sao.ge), в Сербии — Повереник по информации общественного значения и защите данных о личности (poverenik.rs)."
    },
    "breach": {
      "title": "Если данные утекут",
      "text": "Если кто-то чужой сможет увидеть ваши данные, мы напишем об этом вверху этой страницы — в установленном приложении оно появится после обновления, — сразу сообщим в органы по защите данных и в полицию Армении, а тем, кого это касается, — ботом Molvia: что случилось, какие данные и что делать."
    }
  },
  "terms": {
    "title": "Условия использования",
    "what": {
      "title": "Что такое Molvia",
      "text": "Molvia — приложение, где люди отмечают, что стоит покупать и где. Его делает Владимир Ситчихин — частное лицо, Гюмри, Армения. Это не магазин и не реклама."
    },
    "who": {
      "title": "Кто может пользоваться",
      "text": "Вам должно быть 16 лет или больше. Входите вы своим Telegram — другого способа нет."
    },
    "yours": {
      "title": "Ваши записи",
      "text": "Покупки, траты, обмены и счета видите только вы. Оценки и цены другие видят без имени и только тогда, когда их записали хотя бы трое. Подробно — «Данные и приватность»."
    },
    "write": {
      "title": "Что вписывать",
      "text": "То, что вы сами купили и попробовали. Не вписывайте заведомо ложное и чужие личные данные — ни в названия, ни в заметки, ни в сообщения разработчику."
    },
    "catalogue": {
      "title": "Общий справочник",
      "text": "Товары и штрихкоды, которые вы добавили, становятся частью общего справочника и остаются в нём без вашего имени, даже если вы удалите аккаунт."
    },
    "ads": {
      "title": "Без рекламы",
      "text": "В ответах нет рекламы и платных мест — ни сейчас, ни потом."
    },
    "warranty": {
      "title": "Без гарантий",
      "text": "Оценки — это мнения людей, цены — то, что они записали. Приложение дано как есть. Что покупать, решаете вы."
    },
    "free": {
      "title": "Своё — бесплатно",
      "text": "Записывать и видеть своё вы можете бесплатно всегда. Если доступ к чужим цифрам когда-нибудь станет платным, здесь появится новая редакция, и приложение спросит вас заново."
    },
    "changes": {
      "title": "Удаление и изменения",
      "text": "Удалить всё можно в любой момент: в настройках или командой /delete в боте. Если условия или «Данные и приватность» существенно изменятся, приложение спросит согласие заново при следующем входе."
    },
    "contact": {
      "title": "Связь",
      "text": "«Написать разработчику» в настройках."
    }
  },
  "policy": {
    "revised": "Редакция {version} от {day}"
  },
  "consent": {
    "title": "Условия и приватность",
    "body": "Ваши покупки видите только вы. Цены и оценки другие видят без имени и только когда их записали хотя бы трое. Товары, магазины и штрихкоды, которые вы добавите, и ваше слово о чеке видят все — без имени, но и без порога. Рекламы и трекеров нет.",
    "updated": {
      "title": "Условия обновились",
      "body": "Прочитайте, что изменилось, и примите новую редакцию — без этого дальше нельзя.",
      "changes": "Что изменилось"
    },
    "changes": {
      "2": "Назван тот, кто отвечает за ваши данные, — Владимир Ситчихин, Гюмри. Статистика — отметки о визитах и счёт оценок — теперь держится на вашем согласии, и «Учитывать меня в статистике» его отзывает. Прежняя редакция обещала, что другие видят только записанное тремя, — исправлено: товары, магазины и штрихкоды, которые вы добавили, и ваше слово о строке чека видят все, без имени, но и без порога. Добавлены ваши права, куда пожаловаться, кому уходят данные — среди них налоговая Сербии для чеков по ссылке, — срок неактивного аккаунта и что мы делаем при утечке.",
      "3": "Новый получатель — Anthropic (США): тем, кому включено чтение чеков моделью Claude, фото чека целиком уходит ей, а на фото бывает имя покупателя. Пока вы не приняли эту редакцию, ваши чеки читает только наш сервер.",
      "4": "Новая цель: если модель прочитала чек не целиком, разработчик хранит его фото и то, что прочитала модель, до 21 дня после чтения — и после записи или пересъёмки тоже, — чтобы найти, почему строки не прочитались. О таком чеке ему приходит сообщение в Telegram — без товаров, сумм и магазина. Пока вы не приняли эту редакцию, фото вашего чека удаляется при записи, как раньше.",
      "5": "Где ваши данные. Сервер Molvia стоит во Франции, а не в Германии, как говорила прежняя редакция. Anthropic хранит фото чека в США, а считает его в любой стране, где у неё есть мощности, и держит фото и ответ модели до 30 дней (отмеченное её проверкой — до 2 лет, оценку проверки — до 7 лет). Пока вы не приняли эту редакцию, ваши чеки читает только наш сервер.",
      "6": "Новая цель: с вашего согласия на статистику разработчик меряет поиск по тому, что вы взяли по какому запросу, — без имени и номера аккаунта, а выгрузку для замера удаляет после него. В замер идут и запросы, сделанные до этой редакции. Запрос, который ничего не нашёл, может войти в общий словарь поиска — без имени и только если так же сказали хотя бы трое. Пока вы не приняли эту редакцию, ваши запросы в замер не идут — и не идут, пока выключено «Учитывать меня в статистике»."
    },
    "statistics": {
      "title": "Статистика",
      "text": "Мы считаем, возвращаются ли люди и сколько оценок ставят, и меряем поиск по тому, что вы брали по запросу, — числами, без имён; запрос, который ничего не нашёл, может войти в общий словарь поиска, если так же сказали хотя бы трое. Ваши отметки о визитах, оценки, включая снятые, и запросы в этом счёте, пока включено «Учитывать меня в статистике». Выключить можно в настройках, в любой момент."
    },
    "age": "Мне 16 лет или больше",
    "accept": "Принимаю",
    "accept_busy": "Сохраняем…",
    "decline": "Не принимаю",
    "offline": "Без интернета принять нельзя — подключитесь, и кнопка заработает.",
    "error": "Не получилось сохранить согласие. Попробуйте ещё раз.",
    "failed": {
      "title": "Не получилось открыть условия",
      "body": "Сервер не ответил, приняли ли вы условия. Попробуйте ещё раз."
    },
    "lost": {
      "title": "Нет связи",
      "body": "Чтобы проверить, приняли ли вы условия, нужен интернет. Экран попробует сам, когда связь вернётся."
    },
    "leave": {
      "title": "Без согласия Molvia не пользоваться",
      "body": "Ваш аккаунт уже создан: в нём ваш Telegram-id и всё, что вы записали раньше. Можно выйти — и вернуться, когда решите. А можно удалить все данные сразу.",
      "erase": "Удалить мои данные…",
      "back": "Вернуться к условиям"
    }
  },
  "accounts": {
    "title": "Счета",
    "all": "Все",
    "more": "Ещё {n} счёт | Ещё {n} счёта | Ещё {n} счетов",
    "savings_tag": "сбережения",
    "total": "Всего",
    "total_foot": "Можно тратить {spendable} · сбережения {savings}",
    "stale": "Без связи · остатки на {when}",
    "unassigned": "{n} операция не попала в остатки | {n} операции не попали в остатки | {n} операций не попали в остатки",
    "load_failed": "Не удалось загрузить остатки",
    "done": "Готово",
    "savings": "Сбережения",
    "for_spending": "На расходы",
    "balance": "Остаток",
    "no_operations": "Операций пока нет",
    "currency_spending": "{currency} · на расходы",
    "currency_savings": "{currency} · сбережения",
    "error_body": "Сервер не ответил. Записанное не пропало — попробуйте ещё раз",
    "offer": {
      "title": "Где лежат деньги?",
      "body": "Добавьте наличные и карты — остатки будут считаться сами"
    },
    "unassigned_sheet": {
      "title": "Не попали в остатки",
      "meta": "Без счёта с последней сверки. Выберите счёт — остаток пересчитается",
      "all_done": "Все операции на счетах"
    },
    "screen": {
      "spendable": "Можно тратить",
      "rate": "По моему курсу: {rates}",
      "row_checked": "{currency} · сверено {date}",
      "row_started": "{currency} · старт {date}",
      "row_open": "Открыть счёт:",
      "add": "Добавить счёт",
      "archived": "Убранные ({n})",
      "archived_row": "{currency} · {amount} · убран {date}",
      "archived_note": "Убранного счёта нет в выборе у операций. История и остаток сохранены",
      "restore": "Вернуть",
      "restoring": "Возвращаем…",
      "restore_wait": "Вернём, когда будет связь",
      "restored": "«{name}» снова в выборе",
      "removed": "Удалено: {name}",
      "removed_announced": "Удалено: {name}. Вернуть — 10 секунд",
      "archived_done": "«{name}» убран из выбора — он в «Убранных»",
      "offline": "Без связи · остатки на {when}. Счета и сверка ждут связь",
      "unanswered": "Сервер не ответил · остатки на {when}",
      "empty": {
        "body": "Добавьте наличные и карты — остатки будут считаться сами из трат, доходов, обменов и покупок"
      },
      "error": {
        "title": "Не удалось загрузить счета"
      },
      "offline_empty": "Счета появятся, когда интернет вернётся",
      "uncounted": "{n} счёт не посчитан — нет курса | {n} счёта не посчитаны — нет курса | {n} счетов не посчитаны — нет курса",
      "rate_official": "По курсу {bank}: {rates}",
      "rate_mixed": "По курсу дня: {rates}",
      "restore_late": "Поздно: «{name}» уже удалён насовсем",
      "restore_failed": "Счёт не вернулся — проверьте связь и нажмите «Вернуть» ещё раз",
      "rate_banks_and": " и ",
      "transfer": "Перевод между счетами"
    },
    "account": {
      "edit": "Править",
      "approx": "{amount} по моему курсу",
      "balance_hidden": "Остаток скрыт, пока идёт сверка",
      "started": "старт {amount} на {date}",
      "checked": "сверено {date}",
      "operations": "Операции",
      "more": "И ещё {n} операция за {range} | И ещё {n} операции за {range} | И ещё {n} операций за {range}",
      "charged_sub": "{amount} · списано",
      "no_charged_sub": "{amount} · без «списано»",
      "exchange": "Обмен",
      "exchange_from": "из «{name}»: {amount}",
      "exchange_to": "на «{name}»: {amount}",
      "reconcile_row": "Прочее · сверка",
      "reconcile_out": "расход по сверке",
      "reconcile_in": "доход по сверке",
      "empty": {
        "body": "Траты, доходы, обмены и покупки с этим счётом появятся здесь. Пока остаток — это старт"
      },
      "reconcile": "Сверить с фактом",
      "not_found": "Такого счёта нет",
      "to_list": "К счетам",
      "title": "Счёт",
      "unanswered": "Сервер не ответил",
      "error": {
        "title": "Не удалось загрузить счёт"
      },
      "row_open": "Открыть операцию:",
      "archived": "Убран из выбора {date}. История и остаток сохранены",
      "transfer": "Перевести"
    },
    "sheet": {
      "title_add": "Новый счёт",
      "title_edit": "Счёт",
      "meta_add": "Где лежат деньги — видите только вы",
      "meta_has_ops": "Есть операции · старт {date}",
      "name": "Имя",
      "name_placeholder": "Наличные ֏",
      "currency": "Валюта",
      "currency_option": "{name} · {code}",
      "kind": "Для чего",
      "kind_hint": "Сбережения не входят в «можно тратить»",
      "start_day": "На день",
      "start_hint": "Сегодня — остаток на момент, когда счёт заведён: всё, что записано на него потом, его меняет. Прошлый день — остаток на вечер того дня",
      "start_amount": "Было на старте",
      "start_now": "сейчас {amount}",
      "save": "Сохранить",
      "saving": "Сохраняем…",
      "wait_online": "Сохраним, когда будет связь",
      "offline": "Нет связи. Счета меняются только со связью — введённое останется здесь",
      "added": "Счёт «{name}» добавлен",
      "saved": "Счёт сохранён",
      "failed": "Не удалось сохранить счёт — попробуйте ещё раз",
      "conflict": "Счёт изменился на другом устройстве",
      "no_name": "Назовите счёт",
      "name_taken": "Счёт «{name}» уже есть — назовите иначе",
      "bad_start": "Введите остаток — можно 0",
      "delete": "Удалить счёт",
      "deleting": "Удаляем…",
      "delete_offline": "Удалим, когда будет связь",
      "delete_note": "Операций по счёту не было — удалим совсем. 10 секунд можно вернуть",
      "archive": "Убрать из выбора",
      "archiving": "Убираем…",
      "archive_offline": "Уберём, когда будет связь",
      "archive_note": "История и остаток останутся, счёт уйдёт в «Убранные» — оттуда можно вернуть"
    },
    "reconcile": {
      "title": "Сверка",
      "meta": "{name} · {currency}",
      "question": "Сколько на счёте сейчас?",
      "hint": "Пересчитайте наличные или посмотрите в банке. Сколько считает приложение, покажем после — чтобы не подгонять",
      "no_fact": "Введите сумму — можно 0",
      "check": "Сверить",
      "checking": "Сверяем…",
      "wait_online": "Сверим, когда будет связь",
      "offline": "Нет связи. Сверить можно со связью — введённое останется здесь",
      "offline_result": "Нет связи. Сверка посчитана — разницу можно записать со связью",
      "offline_counted": "Нет связи. Сверка посчитана",
      "match_title": "Сходится с приложением",
      "match_body": "Запомним сверку на сегодня, {date}. Следующая начнёт отсюда",
      "mismatch": "Приложение считает {app}, на счёте {fact}",
      "difference": "Разница",
      "edit_fact": "Ввести другую сумму",
      "causes_title": "Что могло дать разницу с {date}",
      "causes_hint": "Поправьте строку — разница пересчитается",
      "cause_no_account_spending": "Трата {amount} без счёта",
      "cause_no_account_income": "Доход {amount} без счёта",
      "cause_no_account_exchange": "Обмен {amount} без счёта",
      "cause_no_charged": "{title} в {sign} без «списано»",
      "cause_no_charged_meta": "{amount} · {date} · посчитано по курсу дня",
      "cause_trip_unpriced": "Покупки {date} без суммы",
      "cause_trip_unpriced_meta": "{place} · {n} позиция без цены | {place} · {n} позиции без цены | {place} · {n} позиций без цены",
      "no_causes_title": "Похоже, какая-то трата не записана",
      "no_causes_body": "С {date} все операции {currency} — на счетах, суммы и «списано» на месте. Вспомните, что могли оплатить мимо приложения",
      "write_difference": "Записать разницу как «Прочее · сверка»",
      "writing": "Записываем разницу…",
      "write_wait_online": "Запишем, когда будет связь",
      "write_after_recount": "Запишем после пересчёта",
      "write_after_answer": "Запишем после ответа в «Покупках»",
      "retry_wait_online": "Повторим, когда будет связь",
      "retry_after_recount": "Повторим после пересчёта",
      "retry_after_answer": "Повторим после ответа в «Покупках»",
      "write_out_note": "Запишем расход {amount} на «{name}»",
      "write_in_note": "Запишем доход {amount} «Прочее» на «{name}»",
      "recounting": "Пересчитаем, когда исправления дойдут до сервера",
      "trips_held": "Запись ждёт вашего ответа в «Покупках» — разницу запишем после него: пока его нет, сервер считает без неё",
      "recounted": "Сохранено — разница пересчитана",
      "written": "Записано «Прочее · сверка»: {amount}",
      "saved_match": "Сверка записана",
      "saved_mismatch": "Сверка записана, разница осталась",
      "note": "сверка",
      "cause_no_account_trip": "Покупки {amount} без счёта",
      "cause_uncounted": "{title} — нечем пересчитать",
      "no_other": "Не загрузились категории — без «Прочее» разницу не записать",
      "failed": "Не удалось сверить — попробуйте ещё раз"
    },
    "picker": {
      "row_spending": "Счёт",
      "row_income": "На счёт",
      "row_given": "Отдал с",
      "row_received": "Получил на",
      "row_trip": "Счёт покупок",
      "row_open": "Выбрать счёт:",
      "none": "Без счёта",
      "none_hint": "Не двигает ни один остаток",
      "meta": "Остатки — на сейчас",
      "group_same": "Счета {currency}",
      "group_other": "Другие валюты",
      "note_loose": "Счёт в другой валюте — появится поле «Списано со счёта»",
      "note_strict": "Здесь только счета {currency}: деньги приходят и уходят в валюте счёта",
      "note_strict_none": "Счетов {currency} нет — операция запишется без счёта",
      "trip_saved": "Счёт покупок: {name}",
      "trip_saved_none": "Счёт покупок: без счёта",
      "note_transfer_to": "Только счета {currency}, кроме «{name}». Перевести в другую валюту — это «Обмен»",
      "note_transfer_from": "Счёт другой валюты — «Куда» придётся выбрать заново"
    },
    "charged": {
      "label": "Списано со счёта, {sign}",
      "hint_empty": "Пусто — посчитаем по курсу дня, будет ≈ {amount}",
      "hint_filled": "«{name}» уменьшится ровно на {amount}",
      "hint_empty_plain": "Пусто — посчитаем по курсу дня"
    },
    "trip_hint": "Позиции без цены не уменьшают остаток. Цены правятся в «Покупках», счёт — здесь: выбор сохраняется сразу",
    "trip_unpriced": "без цены",
    "currency_in": {
      "AMD": "в драмах",
      "RUB": "в рублях",
      "USD": "в долларах",
      "EUR": "в евро",
      "GEL": "в лари",
      "RSD": "в динарах"
    },
    "held_hint": "По счетам на {date}: {amount}",
    "held_fill": "Подставить",
    "card_from": "с «{name}»",
    "card_to": "на «{name}»",
    "card_name": "«{name}»",
    "stale_error": "Не удалось обновить — остатки на {when}"
  },
  "update": {
    "ready": "Вышла новая версия",
    "apply": "Обновить",
    "applying": "Обновляем…",
    "failed": {
      "title": "Не получилось обновить",
      "body": "Закройте Molvia полностью и откройте снова. iPhone: смахните её вверх в переключателе приложений. Android: «Недавние» — смахните Molvia."
    }
  },
  "scanner": {
    "title": "Штрихкод",
    "hint": "Наведите рамку на штрихкод",
    "torch_on": "Включить фонарик",
    "torch_off": "Выключить фонарик",
    "manual": "Ввести вручную",
    "scan": "Сканировать",
    "field": "Цифры под штрихкодом",
    "done": "Готово",
    "try_again": "Проверить снова",
    "insecure_title": "Камере нужно защищённое соединение",
    "insecure_body": "Откройте приложение по адресу с https — или введите цифры кода вручную.",
    "denied_title": "Нет доступа к камере",
    "denied_body": "iPhone: Настройки → Приложения → Safari → Камера → «Разрешить». Android: значок слева от адреса → Разрешения → Камера. Или введите цифры кода вручную.",
    "none_title": "Камеры нет",
    "none_body": "На этом устройстве не нашлась камера. Введите цифры кода вручную.",
    "error_title": "Камера не включилась",
    "error_body": "Возможно, её держит другое приложение. Закройте его и повторите.",
    "reader_title": "Сканер не отвечает",
    "reader_body": "Повторите — или введите цифры кода вручную.",
    "camera_hint_title": "Камера без вопросов",
    "camera_hint_app_body": "Safari спрашивает доступ к камере после каждого запуска Molvia. Чтобы больше не спрашивал, разрешите камеру в Настройках:",
    "camera_hint_app_path": "Настройки → Приложения → Safari → Камера → «Разрешить»",
    "camera_hint_app_search": "Быстрее — найдите «Safari» поиском в Настройках.",
    "camera_hint_app_price": "Это разрешение для всех сайтов в Safari, не только для Molvia.",
    "camera_hint_app_otherwise": "Если ничего не менять, Safari будет спрашивать при каждом запуске — тогда достаточно ответить ему «Разрешить».",
    "camera_hint_tab_body": "Safari спрашивает доступ к камере каждый раз, когда страница загружается заново. Чтобы не спрашивал, разрешите камеру этому сайту:",
    "camera_hint_tab_path": "Меню страницы у адресной строки → Настройки веб-сайта → Камера → «Разрешить»",
    "camera_hint_tab_or": "Или для всех сайтов: Настройки → Приложения → Safari → Камера → «Разрешить».",
    "camera_hint_tab_price": "Так разрешение только для Molvia.",
    "camera_hint_tab_otherwise": "Если ничего не менять, Safari будет спрашивать после каждой перезагрузки — тогда достаточно ответить ему «Разрешить».",
    "camera_hint_ok": "Понятно",
    "camera_hint_offer": "Safari спрашивает каждый раз? Как убрать"
  },
  "budget": {
    "title": "Бюджет",
    "offline_strip": "Без связи · бюджет на {when}",
    "error_strip": "Сервер не ответил — бюджет на {when}",
    "offline_body": "Бюджет этого месяца ещё не загружался на этом телефоне. Он появится, когда вернётся связь",
    "load_error": {
      "title": "Бюджет не загрузился",
      "body": "План и траты месяца не пришли. Попробуйте ещё раз"
    },
    "empty": {
      "title": "Плана пока нет",
      "body": "Задайте, сколько готовы тратить на категорию в месяц, — суммой или долей пришедшего. План переносится на следующие месяцы сам"
    },
    "total": {
      "left": "Осталось по плану",
      "over": "Сверх плана",
      "planned": "План",
      "unplanned": "Вне плана",
      "not_whole": "Не всё посчитано: у части трат или доходов нет курса",
      "awaiting": "Доля пришедшего появится, когда в этом месяце что-то придёт",
      "planned_more": "{amount} и ещё"
    },
    "row": {
      "of": "{spent} из {planned}",
      "share": "{percent} % пришедшего",
      "over": "сверх плана",
      "awaiting": "пока ничего не пришло",
      "archived": "категория убрана"
    },
    "unplanned": "Без плана",
    "add": "Задать план категории",
    "add_offline": "Задать план можно со связью",
    "savings": {
      "title": "Отложить",
      "target": "Цель — {percent} % пришедшего",
      "no_target": "Цель не задана",
      "so_far": "пока {percent}",
      "of": "Разница {difference} из {income}",
      "no_income": "В этом месяце ещё ничего не пришло",
      "not_whole": "Не посчитать: у части трат или доходов нет курса"
    },
    "entry": {
      "none": "не задан",
      "left": "осталось {amount}",
      "over": "сверх плана {amount}"
    },
    "saved": "План «{name}» сохранён",
    "removed": "План «{name}» убран",
    "sheet": {
      "meta": "План на месяц",
      "title_choose": "Новый план",
      "kind": "Как задать план",
      "kind_amount": "Сумма",
      "kind_share": "% от пришедшего",
      "amount": "Сумма в месяц",
      "percent": "Доля пришедшего",
      "amount_hint": "Сколько готовы тратить на эту категорию за месяц",
      "share_hint": "Доля от «Пришло» месяца по курсу месяца: придёт больше — вырастет и план",
      "savings_hint": "Сколько из пришедшего хотите оставлять. Сравнивается с разницей «пришло − ушло»",
      "from": "С {month} и дальше. {before} не меняется",
      "bad_amount": "Введите сумму, например 250 000",
      "bad_percent": "Введите целое число от 0 до {max}",
      "category_gone": "Этой категории больше нет — обновите экран",
      "failed": "Не сохранилось. Попробуйте ещё раз",
      "offline": "Без связи · план сохраняется со связью",
      "save": "Сохранить",
      "saving": "Сохраняем…",
      "save_offline": "Сохранить можно со связью",
      "remove": "Убрать план",
      "removing": "Убираем план…",
      "remove_offline": "Убрать можно со связью",
      "other_currency": "План был {amount}, до смены валюты трат. Введите сумму в {sign}",
      "too_big": "Слишком большая сумма для плана на месяц"
    }
  },
  "place": {
    "quoted": "«{place}»",
    "in_city": "{place} {where}",
    "in_unknown_city": "{place} ({city})",
    "cities_in": {
      "Гюмри": "в Гюмри",
      "Ереван": "в Ереване",
      "Тбилиси": "в Тбилиси",
      "Батуми": "в Батуми",
      "Белград": "в Белграде",
      "Нови-Сад": "в Нови-Саде"
    }
  },
  "receipt": {
    "edges": {
      "title": "Края чека",
      "hint": "Потяните углы к краям чека. У части длинного чека — к линии нахлёста",
      "not_found": "Края не нашли — потяните углы к краям чека сами",
      "flat": "Углы не складываются в чек — разведите их к краям чека",
      "corner": "Угол: {corner}. Двигайте стрелками",
      "corners": {
        "top_left": "верхний левый",
        "top_right": "верхний правый",
        "bottom_right": "нижний правый",
        "bottom_left": "нижний левый"
      },
      "turn": "Повернуть",
      "done": "Готово",
      "narrow": "Чек мелкий — подойдите ближе или снимите частями",
      "closer": "Подойти ближе",
      "keep": "Оставить так"
    },
    "capture": {
      "title": "Сфотографировать чек",
      "hint_flat": "Разгладьте чек и положите на тёмное",
      "hint_top": "Снимайте сверху — весь чек в кадре, без бликов",
      "hint_parts": "Длинный — частями, сверху вниз, с небольшим нахлёстом. До четырёх частей",
      "take": "Снять",
      "pick": "Выбрать фото",
      "one_part": "Короткий чек — хватит одного фото. Длинный — снимите следующую часть с небольшим нахлёстом",
      "parts_order": "Части идут сверху вниз. Коснитесь части, чтобы переснять или убрать",
      "parts": "{n} часть | {n} части | {n} частей",
      "part": "Часть {n}",
      "part_of": "Часть {n} из {total}",
      "part_aria": "Часть {n}: переснять или убрать",
      "add_part": "Ещё часть",
      "max": "Четыре части — это предел. Если чек не влез, переснимите части, отступив чуть дальше",
      "retake": "Переснять",
      "remove_part": "Убрать часть",
      "offline": "Нет связи — фото подождут на телефоне и уйдут сами",
      "bad_file": "Этот файл не открылся как фото. Выберите снимок чека — или снимите заново",
      "not_kept": "Фото не сохранилось на телефоне. Освободите место и попробуйте ещё раз",
      "preparing": "Готовим фото…",
      "send": "Отправить чек",
      "send_busy": "Отправляем чек…",
      "send_offline": "Отправим, когда появится связь",
      "sent": "Чек отправлен",
      "sent_offline": "Чек ждёт связи — отправим сами"
    },
    "sheet": {
      "photos": "Фото чека"
    },
    "review": {
      "title_loading": "Чек",
      "title_no_place": "Чек от {day}",
      "title_sent": "Чек, отправлен {day}",
      "place_line": "{city} · ИНН {inn} · {day}",
      "place_line_time": "{city} · ИНН {inn} · {day}, {time}",
      "place_line_no_tin": "{city} · {day}",
      "sent_day": "{day}, день отправки",
      "place_missing": "Место не прочитали · указать",
      "count_hint": "{count} · тап — поправить",
      "tag_new": "новый товар",
      "tag_check": "проверьте",
      "tag_skip": "не записываем",
      "tag_added": "добавлена",
      "issues_check": "проверьте: {n}",
      "check_note": "в чеке — «{text}»",
      "qty_price": "{qty} × {price}",
      "unread": "Цифры не прочитали — посмотрите в чеке",
      "qty_price_discount": "{qty} × {price} − {discount}",
      "packed": "· {pack}",
      "packed_spoken": "{figures}, запишем {pack}",
      "mismatch": "≠ {printed}",
      "lines": "Строки",
      "total": "Итог чека",
      "total_missing": "Итог не прочитали · указать",
      "cashback": "Кэшбэк на карту",
      "redeemed": "Оплачено бонусом карты",
      "repaired_note": "Цифры поправили — сверьте с бумагой",
      "approx": "≈ {amount} по курсу {day}",
      "diff": "Разница {amount} — похоже, в строке «{line}». Записать можно и так",
      "diff_unknown": "Разница {amount} — строку не нашли. Записать можно и так",
      "diff_blank": "Не хватает {amount} — у {n} строки нет цифр. Записать можно и так | Не хватает {amount} — у {n} строк нет цифр. Записать можно и так | Не хватает {amount} — у {n} строк нет цифр. Записать можно и так",
      "photo_note": "Фото удалим после записи — останутся строки",
      "photo_note_sum": "Фото удалим после записи",
      "partly_total": "Прочитали не всё: строки дают {lines} из {total}, не хватает {short}. Если печать бледная, переснимать не нужно — поправьте строки",
      "partly_read_total": "Прочитали не всё: строки дают {lines} из примерно {total}, не хватает примерно {short}. Если печать бледная, переснимать не нужно — поправьте строки",
      "partly_lines": "Прочитали не всё: сошлось строк — {n} из {total}. Если печать бледная, переснимать не нужно — поправьте строки",
      "partly_check": "Прочитали не всё — сверьте строки с бумагой. Если печать бледная, переснимать не нужно: недостающее можно добавить потом, в записи",
      "no_items": "В чеке нет списка товаров — запишем сумму. Покупки можно добавить потом, в записи",
      "to_developer": "Отправить чек разработчику",
      "record": "Записать {n} покупку | Записать {n} покупки | Записать {n} покупок",
      "record_busy": "Записываем…",
      "record_sum": "Записать сумму",
      "record_offline": "Запишем, когда появится связь",
      "recording": "Запишем, когда появится связь — строки сохранены на телефоне",
      "cancel_record": "Отменить запись",
      "cancel_record_busy": "Проверяем…",
      "cancel_record_offline": "Отменить можно, когда появится связь: запись могла уже дойти до сервера",
      "cancel_record_failed": "Сервер не ответил — попробуйте отменить ещё раз",
      "refused": "Не записали: {reason}. Поправьте и запишите ещё раз",
      "offline": "Без связи · чек из памяти телефона. Правки строк сохраняются здесь",
      "unanswered": "Сервер не ответил · чек из памяти телефона. Правки строк сохраняются здесь",
      "error": {
        "title": "Сервер не ответил",
        "body": "Чек цел. Правки строк, если были, сохранены на телефоне"
      },
      "line_aria": "{name}, {qty}, {sum}",
      "from_tax_office": "Строки — из налоговой Сербии. Сверять с бумагой не нужно.",
      "place_line_pib": "{city} · ПИБ {inn} · {day}",
      "place_line_pib_time": "{city} · ПИБ {inn} · {day}, {time}"
    },
    "added": {
      "add": "Добавить строку",
      "title": "Новая строка",
      "meta": "Её нет среди прочитанных — впишите с бумаги",
      "item_missing": "Выберите товар — без него строку не записать",
      "figures_note": "Можно оставить пустым: обязателен только товар",
      "remove": "Убрать строку",
      "done": "Готово",
      "full": "Больше {max} строк не дописать"
    },
    "line": {
      "title": "Строка чека",
      "meta": "{n} из {total} · {place}",
      "meta_no_place": "{n} из {total}",
      "printed": "Как напечатано",
      "translation": "Перевод: {text}",
      "product": "Товар",
      "product_other": "Другой",
      "check_warn": "Нашли неуверенно: в чеке «{text}». Проверьте товар или выберите другой",
      "name": "Как назвать",
      "name_note": "Такого товара в справочнике нет — заведём его этой записью",
      "spelled_note": "Слова, которых нет в нашем словаре, написаны буквами чека",
      "unspell": "Убрать имя — оставить как в чеке",
      "find": "Найти в справочнике",
      "price": "Цена за всё, как в чеке",
      "weight_hint": "{qty} × {price} — за единицу посчитаем сами",
      "mismatch": "В чеке у строки {printed}, а {qty} × {price} — это {sum}. Поправьте цену или количество — или оставьте как есть: записать это не мешает",
      "remembered": "В прошлый раз здесь было {price} — проверьте цифры",
      "save": "Сохранить",
      "skip": "Не записывать эту строку",
      "unskip": "Вернуть в запись",
      "skipped": "Строку не записываем. В сумме чека она остаётся — она оплачена",
      "discount_hint": "В чеке {price} − {discount}"
    },
    "pick": {
      "title": "Выбрать товар",
      "meta": "Для строки «{printed}»",
      "meta_translation": "Для строки «{printed}» · перевод «{text}»",
      "meta_added": "Для строки, которую дописываете",
      "keep_new": "Оставить новым товаром «{text}»",
      "keep_new_note": "Заведём в справочнике этой записью",
      "note": "Товар — только из справочника: новый заведёт та же кнопка «Записать»",
      "bad_name": "Такое название не подойдёт — сократите его"
    },
    "place": {
      "title": "Где купили?",
      "missing": "Место в чеке не прочитали",
      "read": "Прочитали: {place}, {city}",
      "when": "Когда",
      "city": "Город",
      "done": "Готово",
      "name": "Магазин",
      "choose_place": "Выберите магазин",
      "choose_day": "Выберите день"
    },
    "recorded": {
      "title": "Записали {n} покупку | Записали {n} покупки | Записали {n} покупок",
      "sum_title": "Записали сумму по чеку",
      "body": "Оценить их можно дома — в «Оценках». Любую строку можно поправить и сейчас",
      "to_verdicts": "К оценкам",
      "from_receipt": "из чека",
      "printed_note": "Серым под покупкой — строка, как она напечатана в чеке. Фото удалено"
    },
    "codes": {
      "title": "Привязать штрихкоды?",
      "body": "Налоговая передала коды товаров из чека. Привязанный код найдёт товар сканером — у вас и у всех, кто его отсканирует",
      "skip": "Записать без кодов",
      "held": "Код {code} уже у «{name}» — к покупке его не привязали"
    },
    "failed": {
      "meta": "{parts} · снят {day}, {time}",
      "title": "Не получилось прочитать",
      "body": "Строки на фото не разобрать — так бывает с бледной печатью и бликами. Покупки можно записать вручную или переснять чек.",
      "reshoot_title": "Не нашли ни одной строки",
      "reshoot_body": "Так бывает, когда чек смят, в тени или напечатан бледно. Смятый и в тени — переснимите: чек на весь кадр — частями, если длинный; расправить ладонью; без тени от руки и телефона. Бледную печать переснимок не исправит — запишите покупки вручную.",
      "manual_body": "Строки на фото не разобрать. Покупки можно записать вручную.",
      "photos": "Фото чека · сверху вниз",
      "photos_elsewhere": "Фото снято на другом телефоне — здесь его нет",
      "link": {
        "missing_title": "Налоговая не показала чек",
        "missing_body": "Спрашивали двое суток. Так бывает, если касса работала без связи. Покупки можно записать вручную.",
        "invalid_title": "Налоговая не признаёт этот чек",
        "invalid_body": "Проверка налоговой отвечает, что чек недействителен. Покупки можно записать вручную.",
        "unreadable_title": "Чек не разобрали",
        "unreadable_body": "Покупки можно записать вручную или снять QR чека ещё раз."
      }
    },
    "duplicate": {
      "title": "Этот чек уже записан {day}",
      "body": "У него тот же номер, что у записанного. Второй раз записывать не нужно — этот можно удалить вместе с фото."
    },
    "gone": {
      "title": "Этого чека больше нет",
      "body": "Его удалили — может быть, на другом телефоне.",
      "action": "К покупкам"
    },
    "link": {
      "step_qr": "Наведите камеру телефона на QR внизу чека",
      "step_copy": "Откройте ссылку и скопируйте адрес страницы",
      "step_paste": "Вставьте его сюда",
      "field": "Ссылка с чека",
      "refusal": {
        "not_link": "Это не ссылка с сербского чека",
        "damaged": "Ссылка повреждена — скопируйте её ещё раз",
        "not_sale": "Это не чек покупки — копию, авансовый и учебный чек не записываем",
        "refund": "Это чек возврата — его не записываем"
      }
    },
    "qr": {
      "hint_qr": "Снимите QR внизу чека — крупно и резко",
      "hint_light": "Свет ровный, на QR без бликов",
      "hint_private": "Уйдёт только ссылка из QR — фото не покинет телефон",
      "have_link": "Ссылка уже скопирована?",
      "paste_short": "Вставить",
      "paste": "Вставить ссылку",
      "take": "Снять QR",
      "reading": "Ищем QR…",
      "missed_title": "QR не нашёлся",
      "missed_body": "Подойдите ближе, чтобы QR занял треть кадра. Подержите телефон, пока камера наведёт резкость, и снимайте при ровном свете.",
      "retake": "Снять ещё раз",
      "take_other": "Снять другой",
      "or_take": "QR можно снять камерой",
      "offline": "Нет связи — ссылку из QR отправим сами, как только связь появится",
      "not_kept": "Ссылка не сохранилась: вы вышли из аккаунта. Войдите снова и отправьте чек ещё раз"
    }
  },
  "transfer": {
    "title": "Перевод",
    "title_amend": "Правка перевода",
    "meta": "Между своими счетами одной валюты. В траты месяца не попадает",
    "amount": "Сумма",
    "from": "Откуда",
    "to": "Куда",
    "pick": "Выберите счёт",
    "no_peer_value": "Нет счёта в {sign}",
    "no_peer": "Нет другого счёта {currency}",
    "fee": "Комиссия",
    "fee_hint": "Трата «Прочее» со счёта «{name}»",
    "fee_hint_none": "Трата «Прочее» со счёта, откуда переводите",
    "fee_total": "всего уйдёт {amount}",
    "day": "День",
    "today": "Сегодня",
    "note": "Заметка",
    "note_placeholder": "Необязательно",
    "amended": "исправлен {date}",
    "send": "Перевести {amount}",
    "sending": "Переводим…",
    "save": "Сохранить",
    "saving": "Сохраняем…",
    "need_from": "Выберите, откуда",
    "need_peer": "Нужен второй счёт {currency}",
    "need_amount": "Введите сумму",
    "need_to": "Выберите, куда",
    "wait_online": "Переведём, когда будет связь",
    "wait_online_save": "Сохраним, когда будет связь",
    "offline": "Нет связи. Перевести можно со связью — введённое останется здесь",
    "failed": "Не получилось перевести",
    "failed_retry": "Попробуйте ещё раз",
    "gone": "Счёт «{name}» удалили на другом телефоне. Выберите другой — сумма, комиссия и заметка на месте",
    "done": "Переведено: {amount} на «{name}»",
    "saved": "Перевод сохранён",
    "remove": "Удалить перевод",
    "removing": "Удаляем…",
    "remove_wait": "Удалим, когда будет связь",
    "remove_note": "Вместе с комиссией. Сразу после удаления можно вернуть",
    "removed": "Перевод удалён",
    "removed_sub": "Вместе с комиссией",
    "restored": "Перевод возвращён",
    "restore_late": "Поздно: перевод уже удалён насовсем",
    "restore_failed": "Перевод не вернулся — проверьте связь и нажмите «Вернуть» ещё раз",
    "written_title": "Перевод уже записан",
    "written": "Ответ не дошёл, но перевод {amount} на «{name}» записан. Сохраните, чтобы записать ваши цифры поверх, — второго перевода не будет",
    "conflict_title": "Перевод исправили на другом телефоне",
    "amend_conflict": "Сейчас записано: {details}. Сохраните, чтобы записать ваши цифры поверх",
    "current_fee": "комиссия {amount}",
    "unavailable": "Перевод не открылся — сервер не ответил",
    "unread_offline": "Перевод откроется, когда появится связь",
    "unread_gone": "Строки ушли из журнала. Если его удалили только что, его вернёт «Вернуть» на экране",
    "vanished_title": "Перевода нет — его удалили",
    "vanished": "Сохранять нечего. Если его удалили только что, его вернёт «Вернуть» на экране",
    "vanished_button": "Нечего сохранять",
    "removed_announced": "Перевод удалён вместе с комиссией. Можно вернуть",
    "row_out": "→ {name}",
    "row_in": "← {name}",
    "row_meta": "Перевод",
    "fee_row": "Комиссия за перевод",
    "fee_row_meta": "Прочее · → {name}",
    "fee_spending": "Прочее · комиссия за перевод"
  }
}
